import y1 from "../images/yealink/CP925.webp";
import y2 from "../images/yealink/CP935W.webp";
import y3 from "../images/yealink/CP965.webp";
import y4 from "../images/yealink/t30.webp";
import y5 from "../images/yealink/t31.webp";
import y6 from "../images/yealink/t31w.webp";
import y8 from "../images/yealink/t34w.webp";
import y9 from "../images/yealink/t42u.webp";
import y10 from "../images/yealink/t43u.webp";
import y11 from "../images/yealink/t44u.webp";
import y12 from "../images/yealink/t44w.webp";
import y13 from "../images/yealink/t46u.webp";
import y14 from "../images/yealink/t48u.webp";
import y15 from "../images/yealink/t53.webp";
import y16 from "../images/yealink/t53w.webp";
import y17 from "../images/yealink/t54w.webp";
import y18 from "../images/yealink/t57w.webp";
import y19 from "../images/yealink/t58w.webp";
import y20 from "../images/yealink/t58wp1.webp";
import y21 from "../images/yealink/t30p.webp";
import y22 from "../images/yealink/t31g.webp";
import y23 from "../images/yealink/t31w.webp";
import y24 from "../images/yealink/t33p.webp";
import y25 from "../images/yealink/t33g.webp";
import y26 from "../images/yealink/vp59.webp";
import y28 from "../images/yealink/cam50.webp";
import y27 from "../images/yealink/btn.webp";
import y29 from "../images/yealink/cpn10.webp";
import y30 from "../images/yealink/ax83h.webp";
import y31 from "../images/yealink/exp50.webp";
import y32 from "../images/yealink/exp43.webp";
import y33 from "../images/yealink/mba40.webp";
import y34 from "../images/yealink/android.webp";
import y35 from "../images/yealink/mvcs40.webp";
import y36 from "../images/yealink/mvcs60.webp";
import y37 from "../images/yealink/mvcs90.webp";
import y38 from "../images/yealink/mvc940.webp";
import y39 from "../images/yealink/mvc860.webp";
import y40 from "../images/yealink/mvc640.webp";
import y41 from "../images/yealink/mvc340.webp";
import y42 from "../images/yealink/mba20.webp";
import y43 from "../images/yealink/mba30.webp";
import y44 from "../images/yealink/mba10.webp";
import y45 from "../images/yealink/dva24.webp";
import y46 from "../images/yealink/mba40r.webp";
import y47 from "../images/yealink/zvc860.webp";
import y48 from "../images/yealink/zvcs90.webp";
import y49 from "../images/yealink/mbz.webp";
import y50 from "../images/yealink/c5zr.webp";
import y51 from "../images/yealink/me500.webp";
import y52 from "../images/yealink/dva24z.webp";
import y53 from "../images/yealink/mba10z.webp";
import y54 from "../images/yealink/mba20z.webp";
import y55 from "../images/yealink/mba30z.webp";
import y56 from "../images/yealink/rcz.webp";
import y57 from "../images/yealink/zvc860b.webp";
import y58 from "../images/yealink/uvc85.webp";
import y59 from "../images/yealink/uvc40.webp";
import y60 from "../images/yealink/sv40.webp";
import y61 from "../images/yealink/sv60.webp";
import y62 from "../images/yealink/uvc86.webp";
import y63 from "../images/yealink/uvc84.webp";
import y64 from "../images/yealink/uvc34.webp";
import y65 from "../images/yealink/uvc30r.webp";
import y66 from "../images/yealink/uvc84by.webp";
import y67 from "../images/yealink/uvc30cp.webp";
import y68 from "../images/yealink/roompanelzoom.webp";
import y69 from "../images/yealink/roompanelmicro.webp";
import y70 from "../images/yealink/roomsensorpro.webp";
import y71 from "../images/yealink/roompanelplus.webp";
import y72 from "../images/yealink/roomsensor.webp";
import y73 from "../images/yealink/roompanel.webp";
import y74 from "../images/yealink/rcast.webp";
import y75 from "../images/yealink/cm50.webp";
import y76 from "../images/yealink/ap08.webp";
import y77 from "../images/yealink/cm20.webp";
import y78 from "../images/yealink/cs10.webp";
import y79 from "../images/yealink/cmkit121.webp";
import y80 from "../images/yealink/cp50.webp";
import y81 from "../images/yealink/cpe40.webp";
import y82 from "../images/yealink/vcm36.webp";
import y83 from "../images/yealink/vcm35.webp";
import y84 from "../images/yealink/vcm34.webp";
const yealinkproductdata = [
  {
    id: 26,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "VP59 Smart Video IP Phone in Pakistan",
    metaDescription:"Buy Yealink VP59 Smart Video IP Phone in Pakistan with 8-inch HD touchscreen, 1080p video calling, WiFi/Bluetooth. Best price with warranty for offices & call centers.",
    metaKeywords: "VP59 Smart Video IP Phone Pakistan, Yealink VP59 IP Phone Pakistan, Buy VP59 Video Phone Pakistan, Yealink VP59 Price in Pakistan, Yealink VP59 Smart Video Phone, Yealink VP59 Android IP Phone, Yealink VP59 Teams Edition, Yealink VP59 1080p Video Phone, Yealink VP59 VoIP Phone, Yealink VP59 8 Inch Touch Screen, Yealink VP59 Bluetooth WiFi, Yealink VP59 HDMI Output, Yealink VP59 Dual USB Ports, Yealink VP59 16 VoIP Accounts, Yealink VP59 SIP Phone, Yealink VP59 Android 7.1, Yealink VP59 Executive Desk Phone, Yealink VP59 Huddle Room Solution, Yealink VP59 Video Conferencing Phone",
    // premalink: "company-linkname-producttype-country",
    linkname: 'vp59-video',
    company: 'yealink',
    productType: 'ip-phones',
    country: 'pakistan',
    permalink:'yealink-vp59-smart-video-ip-phone-pakistan',
    fsize: '10px',
    image: y26,
    name: "VP59",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Flagship smart video phone for C-level Executives and workgroups with video collaboration demands',
    backDetails: [`8 inch (1280 x 800) capacitive
adjustable touch screen`,
      `1080p@30 full HD video`,
      `Runs Android 7.1`,
      `Built-in dual band 2.4G/5G Wi-Fi
(802.11a/b/g/n)`,
      `Standard HDMI output for
monitor connection`,
      `Up to 16 VoIP accounts`,
      `Up to 3-party video confe rencing`,
      `Up to 10-party video/audio mixed
conferencing (up to 2 video calls)`,


    ],
  //  Detail page data
    titlename: "Yealink VP59",
    titletagline: "Smart Video IP Phone in Pakistan — The Ultimate Business Desk Phone",
    block1: {
      image: y26,

      title: "Secure, Smarter Communication Starts Here",
      description: `Advance Resources, your trusted official distributor of Yealink in Pakistan, proudly presents the Yealink VP59 Video IP Phone in Pakistan — the ideal solution for SMEs seeking secure, smart, and professional communication. Built with multi-layered protection and cutting-edge TLS 1.3 encryption, the VP59 ensures that every call is secure, fast, and private. With the latest V87 firmware upgrade, your business is further protected with even more advanced security features.`,
    },
    block2: {
      image: y26,
      title: "Ready to Upgrade Your Business Communication?",
      description: `Whether you're searching to buy a VP59 phone in Pakistan, compare the latest VP59 IP Phone prices, or find the best video IP phone in Pakistan, Advance Resources has you covered. The Yealink VP59 is not just a desk phone—it’s a powerful tool for modern SMEs looking to lead with efficiency, security, and flexibility.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",

    Detailspagecards: [
      {
        name: " Crystal-Clear Adjustable Display",
        details: "The Yealink VP59 phone features a high-resolution touchscreen that adjusts to your ideal viewing angle. Whether under office lights or in a home workspace, enjoy an adaptable and immersive screen experience for easier video conferencing and navigation.",
      },
      {
        name: "Acoustic Shield Technology for Noise-Free Calls",
        details:"Say goodbye to distractions. Yealink’s advanced Acoustic Shield Technology filters out background noise using multiple microphones. Perfect for remote meetings, sales calls, or collaborative sessions—this business IP phone ensures every word is heard clearly.",
      },
      {
        name: "Corded + Cordless Flexibility",
        details: "With support for both corded and cordless phone usage via the Yealink DD10K DECT dongle, the VP59 IP Phone gives you the power of seamless mobility. Switch effortlessly between desk phone and DECT handset—ideal for dynamic office environments",
      },
      {
        name: "Superior Wireless Connectivity",
        details: "Stay connected without the clutter. Built-in Bluetooth 4.2 and dual-band Wi-Fi (2.4G/5G) offer smooth pairing with wireless headsets and ensure strong, fast connections across your office. A clean, efficient workspace starts with the right tech.",
      },
      
    ],
    related: [20, 19, 18, 17],
    // fsize, imagesize, bsize, namesizef, namesizeb are used for styling purposes
    fsize: '10px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    
  }, {
    id: 20,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink T58W Pro with Camera in Pakistan",
    metaDescription:"Buy Yealink T58W Pro with Camera in Pakistan. Experience HD video calling, Android interface, and advanced VoIP features. Perfect for business communication setups.",
    metaKeywords: "T58W cheap price in Pakistan, T58W Pro with Camera in Pakistan, Best Prices of Yealink Product in Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "t58w-with-camera",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-t58w-with-camera-ip-phone-pakistan',
    image: y20,
    name: "T58W Pro with Camera",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Elite desktop phone for executives and professionals',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Runs Android 9.0`,
      `7-inch (1024 x 600) capacitive
        adjustable touch screen`,
      `720p30 HD video`,
      `Supports Yealink Bluetooth
        Handset BTH58`,
      `DoorPhone Features`,
      `Built-in Bluetooth 4.2 and Dual
        Band 2.4G/5G Wi-Fi`,
      `Up to 10-party video/audio mixed
        conferencing`


    ],
    // Detail page data
    titlename: "Yealink T58W Pro with Camera",
    titletagline: "IP Phone in Pakistan",
    block1: {
      image: y20,

      title: "Smart Video Collaboration – Made for Modern Workspaces",
      description: `Upgrade your communication experience with the Yealink T58W Pro with Camera in Pakistan—a powerful business phone designed for today’s agile teams. With a large 7-inch adjustable touchscreen, intuitive Android 9.0 interface, and a built-in 5MP HD camera, it’s more than just a voice IP phone—it’s a complete desk collaboration solution.`,
    },
    block2: {
      image: y20,
      title: "Freedom from Cords. Clarity in Every Call.",
      description: `Go wireless with confidence. The Yealink T58W Pro with Camera features a Bluetooth-enabled handset phone that offers full mobility around your workspace. Combined with Yealink’s industry-leading noise-proof technology, every conversation stays crystal-clear—whether you’re taking calls or joining high-quality video meetings.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",

    Detailspagecards: [
      {
        name: "Intelligent Design & Interface",
        details: [
          "The device runs on Android 9.0 OS, delivering a modern and intuitive user experience that is familiar and easy to navigate. It features a 7-inch adjustable touch screen with rich, responsive visuals that enhance usability and workflow. With support for up to 16 SIP accounts, it is designed for high-demand, professional communication environments."
        ]
      },
      {
        name: " Superior Audio Quality",
        details: 
          "Equipped with Yealink’s advanced Noise Proof technology, the phone ensures clear, high-definition sound even in busy office environments. The full-duplex speakerphone with advanced acoustic echo cancellation (AEC) provides a smooth and natural conversation experience. Additionally, it supports the Bluetooth handset phone BTH58, allowing for flexible and wireless audio options."
      },
      {
        name: " High-Definition Video Calls",
        details: "A built-in 5MP HD camera enables high-quality video calls, complete with a privacy shutter for user security. It supports 720p HD video conferencing at 30 frames per second, offering clear and lifelike video interactions that improve remote communication and collaboration."
      },
      
      {
        name: "Seamless Connectivity",
        details: "This device comes with built-in Wi-Fi and Bluetooth for effortless wireless integration. Dual USB 2.0 ports offer additional connectivity options for headsets and storage devices. Dual Gigabit Ethernet ports with Power over Ethernet (PoE) ensure fast, stable wired network connections suitable for enterprise environments."
      },
      {
        name: " Enhanced Productivity",
        details:"Supports up to 10-party audio conferencing and 3-party video conferencing, making it ideal for team meetings and collaborative discussions. The phone also features a standard HDMI output for connecting to external monitors, enhancing the video conferencing experience."
      },
     
    ],

    related: [26, 19, 18, 17],

    // fsize, imagesize, bsize, namesizef, namesizeb are used for styling purposes
    fsize: '11px',
    isize: '80%',
    bsize: '0px',
    namesizef: '19px',
    namesizeb: '15px',
    
  },

  {
    id: 19,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink T58W Pro IP Phone in Pakistan",
    metaDescription: "Buy Original Yealink T58W Pro IP Phone (7-inch Android 9.0) in Pakistan. Features WiFi, Bluetooth & HD voice. Best price with warranty.",
    metaKeywords: "Yealink T58W Pro IP Phone Pakistan, Buy Yealink T58W Pro in Pakistan, Yealink T58W Pro price in Pakistan, Yealink T58W Pro business phone, Yealink T58W Pro SIP phone, Yealink T58W Pro VoIP phone, Yealink T58W Pro HD voice, Yealink T58W Pro 7-inch touchscreen, Yealink T58W Pro Android 9.0, Yealink T58W Pro Bluetooth 4.2, Yealink T58W Pro dual-band Wi-Fi, Yealink T58W Pro 16 SIP accounts, Yealink T58W Pro PoE support, Yealink T58W Pro dual USB ports, Yealink T58W Pro USB headset support, Yealink T58W Pro USB recording, Yealink T58W Pro expansion module compatibility, Yealink T58W Pro wall mountable, Yealink T58W Pro Pakistan online store, Yealink T58W Pro best price Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "t58w-pro",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-t58w-pro-ip-phone-pakistan',
    image: y19,
    name: "T58W Pro",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Elite desktop voip phone for executives and professionals',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Runs Android 9.0`,
      `7-inch (1024 x 600) capacitive
adjustable touch screen`,
      `Supports Yealink Bluetooth
Handset BTH58`,
      `Optimal HD audio, Yealink Noise
Proof Technology`,
      `DoorPhone Features`,
      `Built-in Dual
Band 2.4G/5G WiFi`,
      `Up to 10-party audio
conferencing`


    ],
    // Detail page data
    block1: {
      image: y26,

      title: "Feature-Rich Touchscreen IP Phone",
      description: `7" color touchscreen with USB, Bluetooth, Wi-Fi, and expansion support for up to 180 programmable keys.`,
    },
    block2: {
      image: y26,
      title: "Hassle-Free Deployment",
      description: `Effortless deployment and secure performance with Zero Touch Provisioning, unified firmware, TLS/SSL encryption, and dual firmware protection.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",

    Detailspagecards: [
      {
        name: "Display",
        details: [
          "8 inch (1280 x 800) capacitive",
          "Adjustable touch screen"
        ]
      },
      {
        name: "Video Quality",
        details: [
          "1080p@30 full HD video"
        ]
      },
      {
        name: "Operating System",
        details: [
          "Runs Android 7.1"
        ]
      },
      {
        name: "Wi-Fi",
        details: [
          "Built-in dual band 2.4G/5G Wi-Fi",
          "(802.11a/b/g/n)"
        ]
      },
      {
        name: "HDMI Output",
        details: [
          "Standard HDMI output for monitor connection"
        ]
      },
      {
        name: "VoIP Accounts",
        details: [
          "Up to 16 VoIP accounts"
        ]
      },
      {
        name: "Video Conferencing",
        details: [
          "Up to 3-party video conferencing"
        ]
      },
      {
        name: "Mixed Conferencing",
        details: [
          "Up to 10-party video/audio mixed conferencing",
          "(up to 2 video calls)"
        ]
      }
    ],
    related: [20, 26, 18, 17],
    // fsize, imagesize, bsize, namesizef, namesizeb are used for styling purposes
    fsize: '11px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    
  },
  {
    id: 18,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink SIP-T57W Premium IP Phone in Pakistan",
    metaDescription:"Buy Yealink SIP-T57W Premium IP Phone in Pakistan with 7-inch HD touchscreen, Acoustic Shield technology, and dual-band WiFi. Best price for office communications.",
    metaKeywords: "Yealink SIP-T57W IP Phone Pakistan, Buy Yealink T57W in Pakistan, Yealink T57W price in Pakistan, Yealink T57W business phone, Yealink T57W SIP phone, Yealink T57W VoIP phone, Yealink T57W HD voice, Yealink T57W Acoustic Shield, Yealink T57W 7-inch touchscreen, Yealink T57W adjustable display, Yealink T57W 16 SIP accounts, Yealink T57W Gigabit Ethernet, Yealink T57W PoE support, Yealink T57W built-in Bluetooth 4.2, Yealink T57W dual-band Wi-Fi, Yealink T57W USB 2.0 port, Yealink T57W USB headset support, Yealink T57W USB recording, Yealink T57W expansion module compatibility, Yealink T57W wall mountable, Yealink T57W Pakistan online store, Yealink T57W best price Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t57w-premium",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t57w-premium-ip-phone-pakistan',
    image: y18,
    name: "T57W",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Prime business Large Color Screen Wi Fi voip phones',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`7” 800 x 480 capacitive
adjustable touch screen`,
      `Built-in dual band 2.4G/5G Wi-Fi (802.11a/b/g/n)`,
      `Up to 16 VoIP accounts`,
      `Hearing Aid Compatible Handset`,
      `Paperless label design`


    ],
    // Detail page data
    titlename: "Yealink SIP T57W",
    titletagline: "Premium IP Phone in Pakistan — Elevate Your Business Communication",
    block1: {
      image: y18,

      title: "Experience Next-Gen Personal Collaboration with the Yealink SIP-T57W",
      description: `Looking to upgrade your office desk phone? The Yealink SIP-T57W Premium IP Phone in Pakistan is built for busy executives and professionals who need seamless, high-performance voice communication. Whether you're managing multiple calls or hosting conference discussions, this wireless IP phone offers the perfect blend of functionality and style.`,
    },
    block2: {
      image: y18,
      title: "Built-In Enterprise-Grade Security – Protect What Matters Most",
      description: `The Yealink T57W is not just a premium IP phone in Pakistan — it’s also your first line of defense in secure business communication.
With TLS 1.3 and WPA3 encryption, it ensures your voice traffic stays private and protected from modern threats. Discover more security features in the latest V87 firmware upgrade.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",

    Detailspagecards: [
      {
        name: " Adjustable High-Resolution Display",
        details: " Enjoy a large, intuitive touch screen that’s fully adjustable for comfortable viewing angles — ideal for high-call-volume users.",
      },
      {
        name: " Yealink Acoustic Shield Technology",
        details: " Say goodbye to background noise. With multiple microphones and smart filtering, this feature delivers crystal-clear conversations – perfect for remote meetings and conference calls with headsets",
      },
      {
        name: " Corded + Cordless Functionality",
        details:" Need mobility? The T57W supports DECT handsets (via the DD10K dongle), letting you switch between your desk phone and cordless phone effortlessly",
      },
      {
        name: " Advanced Wireless Connectivity",
        details: "Integrated Bluetooth 4.2 and dual-band Wi-Fi (2.4G/5G) allow for wireless headset pairing and a cable-free, clutter-free desk environment — boosting efficiency for your team.",
      },
      {
        name: " Expandable with EXP50 Modules",
        details: " Connect up to 3 Yealink EXP50 Expansion Modules with color display for more programmable keys — ideal for receptionists or managers handling multiple lines."
      },
      
    
     
    ],
    related: [20, 19, 26, 17],
    fsize: '12px',
    namesizef: '25px',
    namesizeb: '20px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t57w`,
  }, {
    id: 17,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP T54W Prime Business Phone in Pakistan",
    metaDescription:"Buy Yealink SIP-T54W Prime Business IP Phone in Pakistan with 4.3 inch color display, Acoustic Shield, and 16 SIP accounts. Best price for professional offices.",
    metaKeywords: "Yealink SIP T54W IP Phone Pakistan, Buy Yealink T54W in Pakistan, Yealink T54W price in Pakistan, Yealink T54W business phone, Yealink T54W SIP phone, Yealink T54W VoIP phone, Yealink T54W HD voice, Yealink T54W Acoustic Shield, Yealink T54W 4.3-inch color display, Yealink T54W adjustable LCD screen, Yealink T54W 16 SIP accounts, Yealink T54W Gigabit Ethernet, Yealink T54W PoE support, Yealink T54W built-in Bluetooth 4.2, Yealink T54W dual-band Wi-Fi, Yealink T54W USB 2.0 port, Yealink T54W USB headset support, Yealink T54W USB recording, Yealink T54W expansion module compatibility, Yealink T54W wall mountable, Yealink T54W Pakistan online store, Yealink T54W best price Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t54w-prime",
    company: "yealink",
    productType: "business-phone",
    country: "pakistan",
    permalink:'yealink-sip-t54w-prime-business-phone-pakistan',
    image: y17,
    name: "T54W",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Prime business Color Screen Wi Fi voip phones',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`4.3" 480 x 272-pixel color display with backlight`,
      `Adjustable LCD screen`,
      `Dual firmware images`,
      `Built-in dual band 2.4G/5G Wi-Fi (802.11a/b/g/n)`,
      `PoE support`,
      `HAC Handset`,
      `Paperless label design`


    ],
     // Detail page data
    titlename: "Yealink SIP T54W",
    titletagline: "Prime Business Phone in Pakistan",
    block1: {
      image: y17,

      title: "Wireless Desk Phone Designed for Professionals Who Mean Business",
      description: `Discover the power of clear, secure, and efficient communication with the Yealink SIP T54W, a wireless business phone built for modern offices. Whether you're managing a team or running your own SME, this smart office phone redefines your calling experience. Ideal for professionals and managers with a moderate call load, the T54W supports up to 3 EXP50 Expansion Modules for enhanced productivity with self-adaptive color sidecar screens`,
    },
    block2: {
      image: y17,
      title: " T54W IP Phone Price & Availability in Pakistan",
      description: `Looking for the best price on the Yealink SIP T54W Prime Business Phone in Pakistan? Advance Resources offers competitive pricing and expert support to equip your office with the latest VoIP solutions.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",

    Detailspagecards: [
      {
        name: "Adjustable High-Resolution Display",
        details: "The fully adjustable screen offers optimal viewing at any angle, making it the perfect desk phone for diverse lighting setups and office environments."
      },
      {
        name: "Acoustic Shield Technology for Crystal-Clear Audio",
        details: "Yealink’s Acoustic Shield blocks background noise, ensuring your voice is always heard loud and clear—ideal for busy SME environments and conference calls."
      },
      {
        name: " Corded + Cordless Functionality for Flexibility",
        details:"Pair the T54W with DECT handsets (using the DD10K dongle) to switch easily between a cordless phone and your corded office phone setup—enhancing mobility without sacrificing performance."
      },
      {
        name: " Advanced Wireless Connectivity",
        details: "Built-in Bluetooth 4.2 and dual-band Wi-Fi (2.4GHz/5GHz) make this the ultimate wireless business phone. Stay connected with wireless headsets and enjoy clutter-free workspaces with fewer cables."
      },
      {
        name: "Dual Mode Productivity: T54W + BT51",
        details:"Use your Yealink SIP T54W with the BT51 to connect directly to your PC for hybrid meetings via Teams, Zoom, or RingCentral. It supports both SIP and USB modes for seamless internal and external communications—ideal for SMEs adopting hybrid work environments",
      },
      {
        name: "Best-in-Class Security for Office Communications",
        details:"The T54W ensures complete peace of mind with enterprise-grade security:TLS 1.3 protocol for enhanced call encryption,WPA3 Wi-Fi security for strong network protection ,Stay protected with Yealink’s latest V87 firmware upgrade."
      },
      
    ],
    related: [20, 19, 18, 26],
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t54w`,
  },
  {
    id: 16,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T53W IP Phone w/ built-in Bluetooth and Wi-Fi",
    metaDescription:"Buy Yealink SIP-T53W IP Phone in Pakistan with built-in WiFi & Bluetooth. HD voice quality and 3-year warranty. Best price for small businesses.",
    metaKeywords: "SIP T53W Price in Pakistan,Yealink SIP T53W IP Phone Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t53w",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t53w-ip-phone-pakistan',
    image: y16,
    name: "T53W",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Prime business Wi Fi voip phones',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`3.7" 360x160-pixel graphical
LCD with backlight`,
      `Built-in Bluetooth 4.2`,
      `Built-in dual band 2.4G/5G Wi-Fi
(802.11a/b/g/n)`,
      `Up to 12 VoIP accounts`,
      `Hearing Aid Compatible Handset`,
      `Paperless label design`


    ],
    // Detail page data
    titlename: "Yealink SIP T53W",
    titletagline: "IP Phone w/ built-in Bluetooth and Wi-Fi",
    block1: {
      image: y16,

      title: "Redefining Next-Gen Personal Collaboration experience",
      description: `Entry-level phone, well suited for common workspace. Connect up to 3 Expansion Modules EXP50 (Self-adaptive slidecar with color screen) for more line keys`,
    },
    block2: {
      image: y16,
      title: "Build your uncrackable  phone security",
      description: `The T53W is shielded with the latest in security protocols, making your conversations more secure than ever. With TLS 1.3, you benefit from faster and more robust encryption, while WPA3 guards your network against emerging threats.  Learn more enhanced security features in the V87 upgrade.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",

    Detailspagecards: [
      {
        name: "Adjustable High-Resolution Display",
        details: "Aligning with a fully adjustable display, the T5 Business Phone Series can easily fulfill the viewing needs at a variety of angles and under a variety of lighting conditions and finally provides optimized user experience."
      },
      {
        name: "Acoustic Shield technology",
        details: "The Yealink T5 Business Phone Series is designed with Yealink Acoustic Shield technology to deliver distraction-free voice clarity for remote participants by utilizing multiple microphones to create a virtual shield."
      },
      {
        name: "Corded Cordless Phone",
        details:"The Yealink New T5 Business Phone Series supports DECT handset compatibility via a DECT dongle Yealink DD10K, up to 4 cordless handsets. Seamless switching of calls between the desktop phone and the cordless DECT handset.",
      },
      {
        name: "Advanced Wireless Connectivity",
        details: "Built-in Bluetooth 4.2 for wireless headsets connection and enhanced mobility. Wi-Fi 2.4G/5G to help businesses maximize the use of wireless networks, reduce internet cable cost and support clean and uncluttered workspace communications."
      },
      
    ],
    related: [20, 19, 18, 17],

    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t53w`,
  },
  {
    id: 15,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink T53 Business IP Phone in Pakistan",
    metaDescription:"Buy Yealink T53 Business IP Phone in Pakistan. Designed for professionals, it offers HD voice, adjustable display, and enterprise-grade communication features.",
    metaKeywords: "Yealink T53 IP Phone Pakistan, Buy Yealink T53 in Pakistan, Yealink T53 price in Pakistan, Yealink T53 business phone, Yealink T53 SIP phone, Yealink T53 VoIP phone, Yealink T53 HD voice, Yealink T53 Acoustic Shield, Yealink T53 3.7-inch LCD, Yealink T53 adjustable display, Yealink T53 12 SIP accounts, Yealink T53 Gigabit Ethernet, Yealink T53 PoE support, Yealink T53 USB port, Yealink T53 Bluetooth support, Yealink T53 Wi-Fi support, Yealink T53 expansion module, Yealink T53 wall mountable, Yealink T53 Pakistan online store, Yealink T53 best price Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t53",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t53-ip-phone-pakistan',
    image: y15,
    name: "T53",
    subtitle: 'T5 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Prime business voip phones',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [
      `3.7" 360x160-pixel graphical
LCD with backlight`,
      `Bluetooth via BT40`,
      `Wi-Fi via WF40/WF50`,
      `Up to 12 VoIP accounts`,
      `PoE support`,
      `HAC Handset`,
      `Paperless label design`


    ],
    // Detail page data
    titlename: "Yealink T53",
    titletagline: "Business IP Phone in Pakistan",
    block1: {
      image: y15,

      title: "Next-Gen Personal Collaboration Experience",
      description: `Looking for a powerful and easy-to-use Business VoIP Phone in Pakistan? The Yealink T53 Business IP Phone is the perfect entry-level solution for SMEs that need advanced communication tools at an affordable price.
With a high-resolution adjustable display, the Yealink T53 IP Phone ensures comfortable viewing from any angle, whether you're working in bright office lighting or from a flexible workspace setup.`,
    },
    block2: {
      image: y15,
      title: "Uncompromised Security for Your Business",
      description: `The T53 is shielded with the latest in security protocols, making your conversations more secure than ever. With TLS 1.3, you benefit from faster and more robust encryption, while WPA3 guards your network against emerging threats.  Learn more enhanced security features in the V87 upgrade.`,
    },
    Detailspagecards: [
      { name: " Flexible Expansion Options",
        details: "Easily connect up to 3 Expansion Modules EXP50 with adaptive color screens for extra line keys—ideal for managing multiple calls or departments."
      },

      { name: "HD Voice Clarity with Acoustic Shield Technology",
        details: "Experience crystal-clear calls with Yealink’s Acoustic Shield technology. Using multiple microphones, the T53 filters out background noise, delivering HD IP Phone quality audio for distraction-free meetings, especially for remote collaborations."
      },    
      {
        name:". Corded and Cordless DECT Support ",
        details:"Switch seamlessly between desk calls and cordless conversations. The Yealink T53 supports up to 4 DECT cordless handsets using the Yealink DD10K DECT dongle, offering the flexibility of a Cordless Phone or Wireless Office Phone Headset connection.",
      },
      {
        name: "Advanced Wireless Connectivity",
        details: "With Bluetooth 4.2 and dual-band Wi-Fi (2.4G/5G), the T53 gives your business the freedom of wireless communication. Reduce cable clutter while staying connected via Wireless Phone or Cordless Office Phone accessories.",
      },
      {
        name: "Enterprise-Level Security",
        details: "Your business calls are protected with the latest security protocols, including TLS 1.3 encryption for faster, safer communication. The new V87 firmware upgrade further enhances security, keeping your conversations secure from any threats."
      }
    ],
    related: [20, 19, 18, 17],
    pdfFile: "/pdfFiles/comparison.pdf",
    fsize: '12px',
    namesizef: '25px',
    namesizeb: '20px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t53`,
  },
  {
    id: 12,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink SIP T44W in Pakistan - IP Phone",
    metaDescription:"Find the latest Yealink SIP T44W price in Pakistan. Get competitive rates, check availability, and upgrade to a powerful HD VoIP phone with Wi‑Fi & Bluetooth support",
    metaKeywords: "Yealink SIP-T44W IP Phone Pakistan, Buy Yealink T44W in Pakistan, Yealink T44W price in Pakistan, Yealink T44W SIP phone, Yealink T44W VoIP phone, Yealink T44W dual USB ports, Yealink T44W Gigabit Ethernet, Yealink T44W PoE support, Yealink T44W HD voice, Yealink T44W Bluetooth via BT40/BT41, Yealink T44W Wi-Fi via WF40/WF50, Yealink T44W USB headset support, Yealink T44W USB recording, Yealink T44W 2.8-inch color LCD, Yealink T44W programmable DSS keys, Yealink T44W business phone, Yealink T44W Pakistan online store, Yealink T44W expansion module compatibility, Yealink T44W wall mountable phone, Yealink T44W unified firmware support",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t44w",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t44w-ip-phone-pakistan',
    image: y12,
    name: "SIP-T44W",
    subtitle: 'T4 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Feature-rich Color Screen Wi-Fi SIP Phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`2.8” 320x240-pixel color LCD
with backlight`,
      `Built-in Bluetooth 4.2`,
      `Built-in dual band 2.4G/5G Wi-Fi
(802.11a/b/g/ n/ac)`,
      `Up to 12 SIP accounts`,

      `Supports color-screen expansion
modules`


    ],
    //detail page data
    titlename: "Yealink SIP T44W",
    titletagline: "IP Phone – Redefining Business Communication in Pakistan",
    block1: {
      image: y12,
      title: "Looking for the best Yealink SIP T44W Price in Pakistan?",
      description: ` Advance Resources brings you the Yealink T44W, a feature-rich business IP phone designed to help small and medium enterprises in Pakistan streamline their communication effortlessly.`,
    },
    block2: {
      image: y12,
      title: "Boost Productivity with the Next-Gen Yealink T44W",
      description: `The Yealink T44W SIP Phone is part of Yealink's latest T4U series, known for its modern design, enhanced interoperability, and smarter collaboration tools. Whether you're setting up a call center or upgrading your office setup, the T44W IP phone offers everything you need for seamless business communication.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: " Built-in WiFi & Bluetooth – Simplified Deployment",
        details: "With dual-band 2.4G/5G WiFi and Bluetooth 4.2 built-in, the Yealink T44W reduces cabling clutter, making installation faster and more professional. Perfect for businesses aiming for wireless convenience without sacrificing performance."
      },
      {
        name: " Superior Audio Clarity with Yealink Optima HD Voice",
        details: "Experience crystal-clear calls with Yealink's Acoustic Shield and Smart Noise Filtering technologies. The Yealink Business Phone delivers premium audio for productive conversations, even in noisy environments."
      },
      {
        name: " Hassle-Free Management with Zero Touch Provisioning",
        details: "Deploy and manage your devices easily with Yealink's Redirection and Provisioning Service (RPS). The T44W IP Phone supports efficient bulk deployment, saving time for IT administrators in growing SMEs."
      },
      {
        name: " Enterprise-Grade Security",
        details: "Protect your business conversations with the latest security protocols, including TLS 1.3 encryption and WPA3 wireless protection. The Yealink SIP T44W VoIP Phone is built for secure communication in Pakistan’s dynamic business environment."
        
      },
      {
        name: "Color-Screen Expansion Module EXP43",
        details: "Boost your call management capacity with the EXP43 Expansion Module, featuring a 4.3-inch color display and 60 programmable keys—ideal for receptionists and administrators handling large call volumes."
      },
      {
        name: "Seamless Headset Integration",
        details: "Compatible with Yealink wireless and wired USB headsets, the SIP T44W is perfect for call centers and administrative staff requiring hands-free communication.",
      }
    ],
    related: [20, 19, 18, 17],
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t44w`,
  },
  {
    id: 11,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink SIP-T44U IP Phone in Pakistan",
    metaDescription:"Buy Yealink SIP-T44U IP Phone in Pakistan. Featuring HD voice, dual USB ports, and unified firmware, it's perfect for modern business communication.",
    metaKeywords: "Yealink T44U in Pakistan price, Yealink T44W in Pakistan price, Yealink SIP-T44U IP Phone Pakistan, Buy Yealink T44U in Pakistan, Yealink T44U price Pakistan, Yealink SIP-T44U VoIP phone, Yealink T44U features, Yealink T44U dealers Pakistan, Yealink IP phone Lahore, Yealink T44U specifications, Yealink T44U review Pakistan, Yealink T44U vs T46U, Yealink T44U PoE phone, Yealink T44U SIP phone, Yealink T44U for business, Yealink T44U distributor Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t44u",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t44u-ip-phone-pakistan',
    image: y11,
    name: "SIP-T44U",
    subtitle: 'T4 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Well-rounded Color Screen SIP office phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`2.8” 320x240-pixel color LCD
with backlight`,
      `Up to 12 SIP accounts`,
      `Wi-Fi via WF40/WF50`,
      `Bluetooth via BT40/BT41/BT52`,
      `Supports color-screen expansion
modules`


    ],
    // detail page data
    titlename: "Yealink SIP T44U",
    titletagline: "IP Phone in Pakistan – Boost Your Business Communication",
    block1: {
      image: y11,
      title: "Advanced Security with TLS 1.3 Encryption",
      description: `Safeguard your business conversations with cutting-edge security. The Yealink T44U comes with the latest TLS 1.3 encryption, ensuring faster, more robust protection against cyber threats. The V87 firmware upgrade adds even more security features, giving SMEs peace of mind.`,
    },
    block2: {
      image: y11,
      title: "Enhanced Functionality with the EXP43 Color-Screen Expansion Module",
      description: `Need advanced call management? Pair your Yealink T44U with the EXP43 color-screen expansion module. Its 4.3-inch color display offers a simplified user interface and up to 60 programmable keys, perfect for receptionists, call centers, or administrative professionals.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [ 
      {
        name: "Crystal Clear Voice Quality for Every Business Call",
        details: "Experience superior audio with Yealink Optima HD Voice technology. The SIP-T44U IP Phone combines top-tier hardware, innovative software, and wideband technology to deliver remarkable clarity in every conversation—whether you're in a busy office, a remote location, or managing customer support."
      },
      {
        name: "Simplified Deployment and Hassle-Free Management",
        details: "Managing multiple devices is effortless with Yealink's Redirection and Provisioning Service (RPS) and Boot mechanism. The T44U IP Phone supports Zero Touch provisioning, making deployment fast, scalable, and efficient for administrators in SMEs across Pakistan.",
      },
      {
        name: "Seamless Compatibility with Yealink Wireless and Wired Headsets",
        details: "The Yealink SIP-T44U IP Phone works perfectly with both Yealink wireless and wired USB headsets, making it ideal for high-call-volume environments like call centers and executive offices.",
      },
      {
        name: "Enhanced Functionality with the EXP43 Color-Screen Expansion Module",
        details: "Need advanced call management? Pair your Yealink T44U with the EXP43 color-screen expansion module. Its 4.3-inch color display offers a simplified user interface and up to 60 programmable keys, perfect for receptionists, call centers, or administrative professionals."
      },
    ],
    related: [20, 19, 18, 17],
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t44u`,
  },
  {
    id: 14,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink T48U Ultra-elegant Gigabit IP Phone ",
    metaDescription:"Shop the Yealink T48U Ultra-elegant Gigabit IP Phone. Enjoy a 7&quot; touchscreen, HD voice, dual USB ports, and fast Gigabit connectivity for elite business communication.",
    metaKeywords: "T48U IP Phone in Pakistan, Yealink T48U IP Phone Pakistan, Buy Yealink T48U in Pakistan, Yealink T48U price Pakistan, Yealink SIP-T48U VoIP phone, Yealink T48U features, Yealink T48U dealers Pakistan, Yealink IP Phone Lahore, Yealink T48U specifications, Yealink T48U review Pakistan, Yealink T48U vs T46U, Yealink T48U PoE phone, Yealink T48U SIP phone, Yealink T48U for business, Yealink T48U distributor Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t48u-touchscreen",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t48u-touchscreen-ip-phone-pakistan',
    image: y14,
    name: "SIP-T48U",
    subtitle: 'T4 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Advanced Color Screen SIP Office Phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`7" 800 x 480-pixel color touch
screen with backlight`,
      `Paperless label design`,
      `Up to 16 SIP accounts`,
      `Wi-Fi via WF40/WF50`,

      `USB recording`,
      `Supports color-screen expansion
modules`


    ],
    // detail page data
    titlename: "Yealink T48U",
    titletagline: "Ultra-elegant Gigabit IP Phone in Pakistan",
    block1: {
      image: y14,
      title: "The Smart Choice for Executives & Business Professionals in Pakistan",
      description: `Looking to buy the Yealink T48U IP Phone? The Yealink T48U Ultra-elegant Gigabit IP Phone is a premium business IP phone designed for professionals, executives, and decision-makers who demand advanced features with an intuitive interface.
With its sleek design and touchscreen IP phone interface, the Yealink T48U redefines communication for modern offices. Whether you're a growing SME or an established enterprise, this Gigabit VoIP phone ensures seamless collaboration and crystal-clear conversations.
`,
    },
    block2: {
      image: y14,
      title: "Why Choose the Yealink T48U for Your Business?",
      description: `The Yealink T48U is a Gigabit VoIP phone offering both wired and wireless connectivity options, making it ideal for SMEs and large enterprises in Pakistan. It delivers advanced SIP phone functionality, ensuring smooth and reliable business communication across various work environments.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: " Experience Crystal-Clear Audio with Yealink Optima HD Voice",
        details: "The Yealink T48U combines state-of-the-art hardware and software with wideband audio technology, delivering superior sound quality and voice clarity for every call."
      },
    {
        name: " Simplified Deployment & Easy Management",
        details: "Enjoy effortless mass deployment and Zero Touch Provisioning with Yealink's Redirection and Provisioning Service (RPS). The T48U IP phone is a smart investment for IT teams, saving time and effort during setup and device management."
    },
  {
        name: " Expand Your Workflow with the EXP43 Color-Screen Expansion Module",
        details: "Enhance your call-handling capacity with the optional EXP43 expansion module. The 4.3-inch color screen offers up to 60 programmable keys to streamline complex call management tasks."
  },
{
        name: " Seamless Connectivity with Bluetooth & Wi-Fi Dongles",
        details: "Add more flexibility with USB dongles that support Bluetooth, Wi-Fi, and wireless headset connectivity, making the Yealink T48U perfect for modern, agile workspaces."
},{
        name: " Built-in Enterprise-Grade Security",
        details: "Protect your communication with the latest security protocols. The Yealink T48U features TLS 1.3 encryption for faster, more robust data protection. Stay secure with the V87 firmware upgrade, ensuring top-level privacy for sensitive business calls."
  },
  ],
    related: [20, 19, 18, 17],
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t48u`,
  },
  {
    id: 13,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink T46U IP Phone in Pakistan ",
    metaDescription:"Buy Yealink T46U IP Phone in Pakistan. Designed for executives, it features HD audio, dual USB ports, Gigabit Ethernet, and seamless UC integration.",
    metaKeywords: "T46U IP phone price, Yealink T46U IP Phone Pakistan, Buy Yealink T46U in Pakistan, Yealink T46U price Pakistan, Yealink SIP-T46U VoIP phone, Yealink T46U features, Yealink T46U dealers Pakistan, Yealink IP phone Lahore, Yealink T46U specifications, Yealink T46U review Pakistan, Yealink T46U vs T46S, Yealink T46U PoE phone, Yealink T46U SIP phone, Yealink T46U for business, Yealink T46U distributor Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t46u-price-in-pakistan",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
     permalink:'yealink-sip-t46u-price-in-pakistan-ip-phone-pakistan',
    image: y13,
    name: "SIP-T46U",
    subtitle: 'T4 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Productivity-enhancing Color Screen SIP Office / Operator phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [` 4.3" 480 x 272-pixel color display
with backlight`,
      `Up to 16 SIP accounts`,
      `Wi-Fi via WF40/WF50`,
      `Bluetooth via BT40/BT41/BT52`,
      `USB recording`,
      `Supports color-screen expansion
modules`


    ],
    // detail page data
    titlename: "Yealink T46U IP Phone in Pakistan",
    titletagline: "The Ideal Business IP Phone for Professionals",
    block1: {
      image: y13,
      title: "Enhance Productivity with the Yealink T46U Executive SIP Phone",
      description: `The Yealink T46U IP Phone in Pakistan is a powerful business IP phone designed for office professionals, SMEs, and executives who need reliable, high-quality communication tools. Whether you're looking for an office phone or a robust work phone, the T46U Gigabit VoIP Phone is the perfect solution to streamline business communication`
    },
    block2: {
      image: y13,
      title: "Unmatched Audio Quality with Yealink Optima HD Voice",
      description: `Experience crystal-clear audio quality with the Yealink T46U. This VoIP phone features Yealink's Optima HD Voice technology, ensuring every conversation is clear and professional, whether you're in a busy office or a remote location.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Crystal-Clear Audio for Every Call",
        details: "Experience professional-grade audio with Yealink Optima HD Voice technology. The Yealink T46U combines advanced hardware, premium software, and wideband audio to deliver remarkable clarity. Every call feels natural and effortless—perfect for busy offices in Pakistan."
      },
      {
        name: "Effortless Deployment & Management for Your Team",
        details: "Simplify IT operations with Zero Touch Provisioning. The Yealink T4U Series, including the T46U Executive Phone, supports Yealink’s Redirection and Provisioning Service (RPS) for quick and seamless deployment. It’s a hassle-free solution that saves time and reduces labor costs for SMEs and large teams alike."
      },
      {
        name: "Expand Your Communication with the EXP43 Color-Screen Module",
        details: "Upgrade your office setup with the optional EXP43 Expansion Module. Featuring a 4.3-inch color display and up to 60 programmable keys, it allows advanced call handling, streamlined workflow management, and personalized control of communication functions—making your desktop phone even more powerful."
      },
      {
        name: "Flexible Connection Options with Yealink Accessories",
        details: "Enhance your workspace with versatile Yealink accessories. Wi-Fi dongles offer flexible network connectivity, while Bluetooth dongles enable wireless calling and device integration. Wireless headset adapters provide hands-free call control for greater efficiency."
      },
      {
        name: "Build Unbreakable Security for Your Office Communication",
        details: "The Yealink T46U IP Phone is fortified with cutting-edge security. With TLS 1.3 encryption, your calls are safer, faster, and more secure than ever. The latest V87 firmware upgrade offers even more enhanced security features to protect your business communications"
      }
    ],

    related: [20, 19, 18, 17],
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t46u`,
  },
  {
    id: 10,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink T43U SIP Phone in Pakistan",
    metaDescription:"Buy Yealink T43U SIP Phone in Pakistan. Reliable VoIP performance with HD audio, dual USB ports, PoE support, and easy deployment for business environments.",
    metaKeywords: "Yealink T43U SIP Phone Pakistan, Buy Yealink T43U in Pakistan, Yealink T43U price in Pakistan, Yealink T43U IP Phone, Yealink T43U VoIP Phone, Yealink T43U dual USB phone, Yealink T43U 12 SIP accounts, Yealink T43U Gigabit phone, Yealink T43U business phone, Yealink T43U HD voice, Yealink T43U phone features, Yealink T43U Pakistan online store, Yealink T43U expansion module support, Yealink T43U PoE phone, Yealink IP Phones in Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "t43u-sip",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-t43u-sip-phone-pakistan',
    image: y10,
    name: "SIP-T43U",
    subtitle: 'T4 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Feature-rich SIP Office / Operator Phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`3.7" 360x160-pixel graphical LCD
with backlight`,
      `Up to 12 SIP accounts`,
      `USB headset and EHS support`,
      `Wi-Fi via WF40/WF50`,
      `Bluetooth via BT40/BT41/BT52`,
      `Supports color-screen expansion
modules`


    ],
    // detail page data
    titlename: "Yealink T43U SIP Phone in Pakistan",
    titletagline: "The Ideal Business VoIP Phone for Modern Workplaces",
    block1: {
      image: y10,
      title: "Premium Business VoIP Solution in Pakistan",
      description: `The Yealink T43U SIP Phone is a feature-rich business VoIP phone designed for SMEs, co-working spaces, call centers, and administrative teams across Pakistan. With advanced audio quality, flexible connectivity, and robust security, it’s the perfect solution for seamless daily communication.`,
    },
    block2:
    {
        image: y10,
      title: "Built-In Security You Can Trust",
      description: `The Yealink T43U IP phone is equipped with cutting-edge security features, including TLS 1.3 encryption for unbreakable phone security. Enjoy faster, safer communications with the latest V87 firmware upgrade.`,
    },
   pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Crystal-Clear HD Audio for Business Communication",
        details: "Experience HD voice clarity with Yealink Optima HD Voice technology. This HD SIP phone combines top-tier hardware and software with wideband support, delivering maximum acoustic performance for professional conversations."
      },
    {
       name:" Effortless Deployment & Centralized Management",
       details:"The Yealink T4U series, including the T43U IP phone, supports Zero Touch Provisioning via Yealink's Redirection and Provisioning Service (RPS). Administrators can easily manage and deploy multiple devices, saving time and reducing IT costs."
    },{
      name:" Expandable with EXP43 Color-Screen Module",
      details:"Take advantage of the optional EXP43 Expansion Module, featuring a 4.3-inch color screen and up to 60 programmable keys. This allows for streamlined call management, making the T43U a scalable solution for growing businesses."
      
    },
    {
      name:"Flexible Connectivity: Wi-Fi, Bluetooth & Wireless Headsets",
      details:"The Yealink T43U PoE Phone supports optional Wi-Fi via WF40/WF50 and Bluetooth via BT41, allowing users to connect wirelessly or pair with a wireless headset. Perfect for busy teams that need flexible mobility without compromising call quality."
    },
    {
      name:"  Seamless Compatibility with Yealink USB Headsets",
      details:"Pair the Yealink T43U with Yealink wired or wireless USB headsets for enhanced productivity. Ideal for call centers, front-desk workers, or administrative staff handling high call volumes."
    },
    ],
    related: [20, 19, 18, 17],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t43u`,
  },
  {
    id: 9,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink T42U SIP Phone in Pakistan",
    metaDescription:"Buy the Yealink T42U SIP Phone in Pakistan. Offers HD audio, Power over Ethernet (PoE), and efficient call management for small to medium enterprises.",
    metaKeywords: "Yealink T42U SIP Phone Pakistan, Buy Yealink T42U in Pakistan, Yealink T42U price in Pakistan, Yealink T42U IP Phone, Yealink T42U VoIP Phone, Yealink T42U 12 SIP accounts, Yealink T42U Gigabit Ethernet, Yealink T42U PoE support, Yealink T42U HD voice, Yealink T42U dual USB ports, Yealink T42U Bluetooth via BT40/BT41, Yealink T42U Wi-Fi via WF40/WF50, Yealink T42U USB headset support, Yealink T42U USB recording",
    // peramlink: "company-linkname-producttype-country",
    linkname: "t42u-sip",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-t42u-sip-phone-pakistan',
    image: y9,
    name: "SIP-T42U",
    subtitle: 'T4 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Well-rounded SIP desk phones ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`2.7" 192x64-pixel graphical LCD
with backlight`,
      `Up to 12 SIP accounts`,
      `USB headset and EHS support`,
      `Wi-Fi via WF40/WF50`,
      `Bluetooth via BT40/BT41/BT52`,


    ],
    // detail page data
    titlename: "Yealink T42U SIP Phone in Pakistan",
    titletagline: "The Smart VoIP Solution for Your Business",
    block1: {
      image: y9,
      title: "Premium Business VoIP Solution in Pakistan",
      description: `Looking for a business VoIP phone in Pakistan that offers premium sound quality, advanced features, and secure communication? The Yealink T42U SIP Phone is the ideal choice for SMEs, co-working spaces, and corporate offices.
Advance Resources proudly offers the Yealink T42U SIP Phone in Pakistan, designed to simplify communication while enhancing productivity.`,
    },
    block2: {
      image: y9,
      title: "Why choose the Yealink T42U for your business?",
      description: `The Yealink T42U SIP Phone delivers HD voice quality for crystal-clear, professional calls, ensuring effective communication in any business setting. It supports both wired and wireless headsets, offering flexibility to suit different user preferences. With easy deployment through zero touch provisioning, setup is quick and hassle-free. For added versatility, the phone is compatible with optional Bluetooth and Wi-Fi dongles. It also comes equipped with advanced security features, providing peace of mind by safeguarding sensitive business communications.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Crystal-Clear HD Audio with Yealink Optima HD Voice",
        details: "Experience outstanding call clarity with Yealink Optima HD Voice technology. This HD SIP phone combines advanced hardware and wideband audio software, ensuring that every conversation sounds natural and lifelike—perfect for busy work environments.",
      },
      {
        name: "Effortless Setup & Efficient Management",
        details: "Simplify device deployment with Zero Touch Provisioning and Yealink’s Redirection and Provisioning Service (RPS). The T4U Series makes mass deployment and management fast, efficient, and hassle-free—ideal for IT administrators managing multiple office phones."
      },
      {
        name:" Supports Yealink Wired and Wireless USB Headsets",
        details:"Need hands-free flexibility? The Yealink T42U IP Phone works seamlessly with Yealink wired and wireless USB headsets, making it a top choice for call centers, administrative staff, and professionals handling high call volumes.",
      },
      {
        name:" Expandable with Bluetooth, Wi-Fi & Wireless Headsets",
        details:"Easily add wireless connectivity with optional Bluetooth and Wi-Fi USB dongles, allowing smooth integration with wireless headsets and networks. This feature gives your team freedom to work without being tethered to their desks.",
      },
      {
        name:" Enterprise-Grade Security You Can Trust",
        details:"Keep your communications secure with advanced encryption. The Yealink T42U PoE phone is equipped with TLS 1.3 for faster, more reliable security protocols. With the V87 upgrade, enjoy even more robust security features for safe and confidential conversations."
      }
    ],
    related: [20, 19, 18, 17],

    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t42u`,
  },
  {
    id: 8,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP- T34W Business IP Phone in Pakistan",
    metaDescription:"Buy Yealink SIP-T34W Business IP Phone in Pakistan. Enjoy built-in Wi-Fi, HD voice, 2.4&quot; color display, and robust performance for everyday business communication.",
    metaKeywords: "Yealink SIP-T34W, Yealink T34W IP Phone, Business IP Phone Pakistan, Yealink IP Phone Pakistan, SIP-T34W Price Pakistan, Wireless IP Phone Pakistan, VoIP Phone Yealink, Office IP Phones Pakistan, Buy Yealink SIP-T34W, IP Phones for Business, Yealink Phones Pakistan, SIP Business Phone Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t34w-business-ip-phone",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t34w-business-ip-phone-pakistan',
    image: y8,
    name: "SIP-T34W",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Cost-effective Wi Fi IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.4” 320 x 240-pixel color
display with backlight`, `Built-in dual band 2.4G/5G Wi-Fi
(802.11a/b/ g/n/ac)`,

      `Up to 4 SIP accounts`,
      `PoE support`,
      `Local 5-way conferencing`,


    ],
    // detail page data
    titlename: "Yealink SIP-T34W Business IP Phone in Pakistan",
    titletagline: "Wireless Work Phone for SMEs",
    block1: {
      image: y8,

      title: "Enhanced Business Communication with Yealink T34W",
      description: `Looking for a reliable business phone that simplifies communication and enhances efficiency?
 The Yealink SIP-T34W Business IP Phone in Pakistan is the perfect solution for small and medium enterprises. With wireless connectivity, HD audio, and a modern design, it transforms everyday business calls into smooth, productive conversations.`,
    },
    block2: {
      image: y8,
      title: "Why choose the Yealink SIP-T34W for your business?",
      description: ` This wireless VoIP phone offers a clean, cable-free setup and enables fast deployment, making it ideal for modern workplaces in Pakistan. Designed specifically for growing enterprises, the T34W combines functionality with scalability, supporting both USB headset and Bluetooth connections for flexible communication options. It also stands out for its affordability, offering a competitive price without compromising on quality. Now available across Pakistan, the Yealink T34W is a smart choice for small and medium-sized enterprises looking to upgrade their business communication systems.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: " Wireless VoIP Phone for Easy Deployment",
        details: "The Yealink T34W supports 2.4G/5G built-in WiFi, eliminating messy cabling and allowing for effortless installation. Whether you’re setting up in an office, a remote workspace, or a co-working environment, this wireless VoIP phone in Pakistan helps you stay connected with minimal setup time."
      },
      {
        name: "Crystal-Clear HD Audio for Better Communication",
        details: "Say goodbye to background noise during important business calls. The Yealink T34W features Smart Noise Filtering Technology, offering superior HD audio for clear, distraction-free conversations. It’s the ideal work phone for busy offices in Pakistan.",
      },{
        name: "Modern Design with Practical Details",
        details: "Built for comfort and efficiency, the Yealink T34W features a 2.4-inch color screen IP phone display with a 320x240 resolution, providing vibrant and clear visuals. It incorporates hall switch technology for silent pickup and hang-up, eliminating traditional clicking sounds. Designed for versatility, the phone includes an adjustable stand and a wall mount option to accommodate various installation needs. Additionally, a USB 2.0 port allows users to connect Yealink wired or Bluetooth headsets via the BT50 or BT51A adapter, enhancing communication convenience."
      },
      {
        name: "Advanced Security for Peace of Mind",
        details: "With TLS 1.3 encryption and WPA3 network protection, the Yealink SIP-T34W safeguards your business conversations. Stay secure from emerging cyber threats and protect sensitive information with Yealink’s latest security upgrades",
      },
        {
        name: " Simple Management with Yealink’s All-in-One Platform",
        details: "The Yealink SIP-T34W Business IP Phone is compatible with the Yealink Device Management Platform. This reduces IT maintenance time and lowers operational costs for SMEs. Enjoy streamlined management and unified firmware across all your Yealink devices."
      }
      ],
    related: [20, 19, 18, 17],
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    namesizef: '25px',
    namesizeb: '20px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t34w`,
  },
  {
    id: 25,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink T33G IP Phone in Pakistan",
    metaDescription:"Buy the Yealink T33G IP Phone in Pakistan. Features include HD audio, Gigabit Ethernet, PoE support, and an intuitive user interface perfect for office environments.",
    metaKeywords: "Yealink SIP-T34W, Yealink T34W IP Phone, Business IP Phone Pakistan, Yealink IP Phone Pakistan, SIP-T34W Price Pakistan, Wireless IP Phone Pakistan, VoIP Phone Yealink, Office IP Phones Pakistan, Buy Yealink SIP-T34W, IP Phones for Business, Yealink Phones Pakistan, SIP Business Phone Pakistan, Buy Yealink T34W Lahore, Karachi IP Phones, Best Business Phones Pakistan, Yealink Distributor Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "t33g",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-t33g-ip-phone-pakistan',
    image: y25,
    name: "T33G",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Cost-effective color screen Gigabit IP phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.4” 320 x 240-pixel color display
with backlight`,
      `Up to 4 SIP accounts`,
      `PoE support`,
      `Local 5-way conferencing`,


    ],
    // detail page data
    titlename: "Yealink T33G IP Phone in Pakistan",
    titletagline: "Powerful, Secure & Business-Ready",
    block1: {
      image: y25,
      title: "Simplify Your Communication. Empower Your Business.",
      description: `Looking for a business phone that combines performance, security, and affordability? The Yealink T33G IP Phone in Pakistan is the perfect solution for small and medium enterprises aiming to enhance communication without breaking the bank.`,
    },
    block2: {
      image: y25,
      title: "Why Choose the Yealink T33G for Your Business?",
      description: `The Yealink T33G is an affordable and reliable VoIP phone solution, ideal for small and medium-sized enterprises in Pakistan. It offers cost-effective pricing without compromising on quality, making it a smart investment for growing businesses. As a trusted and classic VoIP phone, the T33G is designed for professional use, featuring a color screen for an easy-to-navigate interface. Whether used as a work phone or a business phone, it delivers dependable performance for everyday office communication.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Stronger Performance, Smoother Workflows",
        details: "The Yealink T33G belongs to the advanced T3 series, featuring a next-generation chipset that boosts performance for daily business operations. With faster processing and improved capabilities, this Gigabit VoIP phone in Pakistan ensures seamless calling, multi-tasking, and productivity, whether you're in a startup or a growing SME."
      },
      {
        name: "Crystal Clear Communication with HD Audio",
        details: "Thanks to Yealink’s Smart Noise Filtering Technology, the Yealink T33G features premium HD audio that eliminates background noise. Enjoy distraction-free conversations and reliable sound clarity, making your work phone more efficient for client calls and team collaboration."
      },
      {
        name: "Modern Design with Practical Features",
        details:"The Yealink T33G IP Phone offers a user-friendly design with a 2.4\" color display for clear visibility, an adjustable stand for flexible placement, and a wall-mountable option. Hall Switch Technology ensures silent handset pick-up and extends device lifespan, making it ideal for efficient daily office use."
      },
      {
        name:"Convenient Management & Easy Deployment",
        details: "The Yealink T33G works seamlessly with the Yealink Device Management Platform, making deployment, updates, and configuration simple. SMEs can save time and cut maintenance costs by managing multiple devices through one unified system.",
      },
      {
        name:"Built-In Security for Business Protection",
        details: "Worried about call security? The T33G IP Phone is equipped with TLS 1.3 encryption, safeguarding your business conversations with the highest level of data protection. The new V87 firmware upgrade also offers enhanced security features for peace of mind.",
      },
      
    ],
    related: [20, 19, 18, 17],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',

    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t33g`,
  },
  {
    id: 24,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T33P Classic Business IP Phone in Pakistan",
    metaDescription:"Shop Yealink SIP-T33P Classic Business IP Phone in Pakistan. Reliable VoIP solution for offices with HD voice, multiple lines, and easy configuration. Best price and fast delivery.",
    metaKeywords: "Yealink SIP-T33P, Yealink SIP-T33P IP phone, Yealink T33P price in Pakistan, business IP phone Pakistan, VoIP phone in Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink T33P features, Yealink T33P specifications, Yealink T33P dealers Pakistan",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t33p-classic-business",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t33p-classic-business-ip-phone-pakistan',
    image: y24,
    name: "T33P",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Cost-effective color screen IP phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.4” 320 x 240-pixel color display
with backlight`,
      `Up to 4 SIP accounts`,
      `PoE support`,
      `Local 5-way conferencing`,


    ],
    // detail page data
    titlename: "Yealink SIP‑T33P Classic Business IP Phone in Pakistan",
    titletagline: "Classic Business IP Phone in Pakistan",
    block1: {
      image: y24,
      title: "Empower Your Business Communication with Yealink T33P",
      description: `Looking for a reliable, budget-friendly business IP phone? The Yealink SIP‑T33P Classic Business IP Phone in Pakistan is designed to streamline your office communication while offering powerful features at an affordable price.`,
    },
    block2: {
      image: y24,
      title: "Why Choose the Yealink SIP-T33P for Your Business?",
      description: `The Yealink T33P is an affordable and reliable VoIP phone solution, ideal for small and medium-sized enterprises in Pakistan. It offers cost-effective pricing without compromising on quality, making it a smart investment for growing businesses. As a trusted and classic VoIP phone, the T33P is designed for professional use, featuring a color screen for an easy-to-navigate interface. Whether used as a work phone or a business phone, it delivers dependable performance for everyday office communication.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Stronger Performance, Smarter Office Communication",
        details: "The Yealink T33P is equipped with an advanced chipset, delivering superior computing power and smoother functionality. Whether you’re running a startup or managing a growing business, this Classic VoIP Phone in Pakistan meets diverse communication needs with upgraded performance and flexibility."
      },
      {
        name: "Crystal-Clear HD Audio with Smart Noise Filtering",
        details: "Say goodbye to distractions! The Yealink Telephony system in the T33P uses Smart Noise Filtering Technology to ensure crisp, clear calls without background noise. Experience professional-grade communication in every conversation."
      },
      {
        name: "Modern Design with User-Friendly Details",
        details:"Inspired by Yealink’s signature design language, the Yealink SIP-T33P features a 2.4\" color screen IP phone display (320 x 240-pixel resolution) with backlight, providing an intuitive and vibrant interface. The adjustable multi-angle stand makes it adaptable for various working environments, whether on a desk or wall-mounted."
      },
      {
        name:"Hall Switch Technology",
        details: " Eliminates popping sounds when picking up or hanging up the handset, ensuring quieter operation and longer product life.",
      },
      {
        name:"Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T33P features an adjustable stand and wall mount option, customize the viewing angle for ergonomic comfort.  Flexible installation for different office setups (Note: Wall plate compatibility varies).",
      },
      {
        name:"Easy Deployment & Centralized Management",
        details:"With Yealink’s unified firmware and integration into the Yealink Device Management Platform, managing the T33P is simple. Reduce operational costs and manage multiple devices effortlessly—perfect for SMEs in Pakistan scaling up their telephony solutions.",
      },
      {
        name:"Uncompromised Security with V87 Upgrade",
        details:"The Yealink SIP-T33P includes the latest security protocols, such as TLS 1.3, for faster and more secure encryption. Protect your business calls with robust, enterprise-level security—right out of the box.",
      },
    ],
    related: [20, 19, 18, 17],
    fsize: '12px',
    isize: '100%',
    namesizef: '25px',
    namesizeb: '20px',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t33p`,
  },
  {
    id: 6,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T31W - Classic Business WIFI and wired Phone in Pakistan",
    metaDescription:"Buy Yealink SIP-T31W Classic Business WIFI and Wired Phone in Pakistan. Enjoy HD voice, dual connectivity, and smooth office communication.",
    metaKeywords: "Yealink SIP-T31W, Yealink SIP-T31W IP phone, Yealink T31W price in Pakistan, business IP phone Pakistan, VoIP phone in Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink T31W features, Yealink T31W specifications, Yealink T31W dealers Pakistan, entry-level IP phone, Yealink T31W for offices, Yealink VoIP phones, affordable IP phone Pakistan, classic business IP phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t31w-classic-business-wifi-wired",
    company: "yealink",
    permalink:'yealink-sip-t31w-classic-business-wifi-wired-ip-phone-pakistan',
    productType: "phone",
    country: "pakistan",
    image: y6,
    name: "SIP-T31W",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Entry level Wi Fi IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.3” 132x64-pixel graphical LCD
with backlight`,
      `Built-in dual band 2.4G/5G Wi-Fi
(802.11a/ b/g/n/ac)`,

      `PoE support`,
      `Up to 2 SIP accounts`,
      `Local 5-way conferencing`,


    ],
    // detail page data
    titlename: "Yealink SIP-T31W IP Phone in Pakistan",
    titletagline: "Classic Business WIFI and Wired Phone in Pakistan",
    block1: {
      image: y6,
      title: "Smart Communication for Growing Businesses",
      description: `Looking for a cost-effective and powerful business desk phone? The Yealink SIP-T31W Classic Business Phone in Pakistan is the perfect solution for SMEs seeking reliable communication. Whether you need a wired IP phone in Pakistan or prefer a Yealink WiFi phone for flexible deployment, the T31W has you covered.`,
    },
    block2: {
      image: y6,
      title: "Why Choose the Yealink SIP-T31W?",
      description: `Enjoy the flexibility of dual connectivity with our business IP phone in Pakistan—use it as a Wi-Fi phone or connect via Ethernet for reliable performance. Experience crystal-clear conversations with HD audio and advanced noise filtering, perfect for professional, distraction-free communication. Security is a top priority, featuring TLS 1.3 and WPA3 encryption to protect your data. Installation is simple, thanks to an adjustable stand and wall-mount options. Plus, manage your devices with ease through full compatibility with the Yealink Device Management Platform, making it ideal for growing businesses.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Built-in WiFi – Quick Setup, No Hassle",
        details: "With dual-band 2.4G/5G WiFi, the Yealink SIP-T31W offers seamless wireless connectivity, reducing the need for extra cables. This makes it ideal for businesses looking to create a clean, efficient, and modern workspace without sacrificing performance."
      },
      {
        name: "Crystal-Clear HD Audio – Professional Call Quality",
        details: "The Yealink SIP-T31W features advanced Smart Noise Filtering Technology from the trusted Yealink T3 series. Enjoy crystal-clear conversations without background distractions—perfect for busy office environments where communication is key."
      },
      {
        name: "Classic Design with Practical Features",
        details: "Inspired by Yealink's signature design philosophy, this business IP phone in Pakistan combines modern looks with user-friendly ergonomics. The adjustable multi-angle stand and optional wall-mounting make it adaptable to various office setups."
      },
      {
        name: "Hall Switch Technology",
        details: " Eliminates popping sounds when picking up or hanging up, ensuring a quieter office atmosphere and prolonging device life.",
      },
      {
        name: "Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T31W features an adjustable stand and wall mount option, providing multiple angles for comfortable viewing and operation.Flexibility installation to suit any office environment.",
      },
      {
        name: "Enterprise-Grade Security",
        details: "Protect your business communications with the latest security protocols. The Yealink SIP-T31W supports TLS 1.3 for faster, stronger encryption and WPA3 WiFi security to guard against modern cyber threats. Stay secure and compliant with the V87 upgrade's enhanced security features."
      },
      {
        name:"Centralized Device Management",
        details: "Managing your business phone system has never been easier. With Yealink’s Device Management Platform, the SIP-T31W phone allows for effortless deployment, remote updates, and unified firmware—reducing operational costs and simplifying IT management."
      }
    ],
    related: [20, 19, 18, 17],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '80%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t31w`,
  },
  {
    id: 23,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T31P Classic IP Phone in Pakistan",
    metaDescription:"Buy the Yealink SIP‑T31P Classic IP Phone in Pakistan. A reliable and efficient VoIP desk phone offering HD audio, PoE support, and streamlined telephony for business needs.",
    metaKeywords: "Yealink SIP-T31P, Yealink SIP-T31P IP phone, Yealink T31P price in Pakistan, business IP phone Pakistan, VoIP phone in Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink T31P features, Yealink T31P specifications, Yealink T31P dealers Pakistan, entry-level IP phone, Yealink T31P for offices, Yealink VoIP phones, affordable IP phone Pakistan, classic business IP phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t31p",
    company: "yealink",
    productType: "classic-phone",
    country: "pakistan",
    permalink:'yealink-sip-t31p-classic-phone-pakistan',
    image: y23,
    name: "SIP-T31P",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Dual-line entry level IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.3” 132x64-pixel graphical LCD
with backlight`,
      `Up to 2 SIP accounts`,
      `PoE support`,
      `Local 5-way conferencing`


    ],
    // detail page data
    titlename: "Yealink SIP-T31P Classic IP Phone in Pakistan",
    titletagline: "Affordable VoIP Solution for Small Businesses",
    block1: {
      image: y23,
      title: "Facilitate Seamless Business Communication with Yealink",
      description: `Looking for a reliable business desk phone that enhances productivity and delivers crystal-clear communication? The Yealink SIP‑T31P Classic IP Phone in Pakistan is your go-to solution. Whether you're upgrading your business phone system or starting fresh, the T31P IP Phone is a smart investment for SMEs across Pakistan.`,
    },
    block2: {
      image: y23,
      title: "Why Choose the Yealink SIP-T31P?g",
      description: `Looking for an affordable business IP phone in Pakistan? Our VoIP solutions offer smooth and secure communication tailored for small and medium-sized enterprises. Designed with proven quality and durability, these IP phones ensure long-term performance and reliability. They easily integrate into your existing business phone systems, making setup hassle-free and cost-effective. Whether you're upgrading or starting fresh, our IP phones provide a professional communication experience without breaking the budget.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Powerful Performance for Growing Businesses",
        details: "The Yealink T3 Series, including the T31P IP Phone, is powered by an advanced chipset, ensuring faster operation, smoother performance, and more scalability. This classic VoIP phone in Pakistan is perfect for businesses looking to extend communication capabilities without compromising quality."
      },  
      {
        name: "Superior HD Audio with Smart Noise Filtering",
        details: "Enjoy flawless conversations with Yealink's industry-leading audio technology. The T31P features Smart Noise Filtering, eliminating background disturbances and allowing you to focus on what matters—your business communication."
      },
      {
        name: "Elegant Design Meets Practical Functionality",
        details: "Designed by Yealink’s original team, the T31P desk phone combines a classic design with modern ergonomic details for easier, more intuitive use. From its adjustable multi-angle stand to its wall-mountable option, it fits seamlessly into any office setup.",
      },
      {
        name: "Hall Switch Technology",
        details: "The T31P features a hall switch for silent pickup and hang-up, eliminating the popping sounds for a quieter work environment. This makes it ideal for professional environments where discretion is key.",

      },
      {
        name: "Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T31P features an adjustable stand and wall mount option, providing flexibility in placement to suit any office environment. Its design ensures comfort during use, making it a practical choice for busy professionals.",
      },
      {
        name: "Easy Management with Unified Platform",
        details: "Simplify your operations with Yealink Device Management Platform. The T31P IP Phone supports unified firmware for easy deployment, centralized control, and reduced IT maintenance costs—ideal for SMEs aiming to optimize their IP phone system."
      },
      {
        name: "Advanced Security for Peace of Mind",
        details: "The Yealink T31P is equipped with TLS 1.3 encryption, offering faster and stronger protection for your conversations. The latest V87 upgrade further enhances security, keeping your communications private and secure."
      }

    ],
    related: [20, 19, 18, 17],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '80%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t31p`,
  },
  {
    id: 22,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T31G Classic IP Phone in Pakistan",
    metaDescription:"Buy Yealink SIP-T31G Classic IP Phone in Pakistan. Enjoy HD audio, dual Gigabit ports, and reliable VoIP performance for small to medium businesses.",
    metaKeywords: "Yealink SIP-T31G, Yealink SIP-T31G IP phone, Yealink T31G price in Pakistan, business IP phone Pakistan, VoIP phone in Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink T31G features, Yealink T31G specifications, Yealink T31G dealers Pakistan, entry-level IP phone, Yealink T31G for offices, Yealink VoIP phones, affordable IP phone Pakistan, classic business IP phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t31g",
    company: "yealink",
    productType: "classic-phone",
    country: "pakistan",
    permalink:'yealink-sip-t31g-classic-phone-pakistan',
    image: y22,
    name: "SIP-T31G",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Dual-line entry level Gigabit IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.3” 132x64-pixel graphical LCD
with backlight`,
      `Up to 2 SIP accounts`,
      `PoE support`,
      `Local 5-way conferencing`


    ],
    //Detail page data
    titlename:'',
    titletagline:'',
    block1: {
      image: y22,
      title: "Facilitate Seamless Business Communication with Yealink",
      description: `Looking for a reliable business desk phone that enhances productivity and delivers crystal-clear communication? The Yealink SIP‑T31G Classic IP Phone in Pakistan is your go-to solution. Whether you're upgrading your business phone system or starting fresh, the T31G IP Phone is a smart investment for SMEs across Pakistan.`,
    },
    block2: {
      image: y22,
      title: "Why Choose the Yealink SIP-T31P?g",
      description: `Looking for an affordable business IP phone in Pakistan? Our VoIP solutions offer smooth and secure communication tailored for small and medium-sized enterprises. Designed with proven quality and durability, these IP phones ensure long-term performance and reliability. They easily integrate into your existing business phone systems, making setup hassle-free and cost-effective. Whether you're upgrading or starting fresh, our IP phones provide a professional communication experience without breaking the budget.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Powerful Performance for Growing Businesses",
        details: "The Yealink T3 Series, including the T31G IP Phone, is powered by an advanced chipset, ensuring faster operation, smoother performance, and more scalability. This classic VoIP phone in Pakistan is perfect for businesses looking to extend communication capabilities without compromising quality."
      },  
      {
        name: "Superior HD Audio with Smart Noise Filtering",
        details: "Enjoy flawless conversations with Yealink's industry-leading audio technology. The T31G features Smart Noise Filtering, eliminating background disturbances and allowing you to focus on what matters—your business communication."
      },
      {
        name: "Elegant Design Meets Practical Functionality",
        details: "Designed by Yealink’s original team, the T31P desk phone combines a classic design with modern ergonomic details for easier, more intuitive use. From its adjustable multi-angle stand to its wall-mountable option, it fits seamlessly into any office setup.",
      },
      {
        name: "Hall Switch Technology",
        details: "The T31G features a hall switch for silent pickup and hang-up, eliminating the popping sounds for a quieter work environment. This makes it ideal for professional environments where discretion is key.",

      },
      {
        name: "Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T31G features an adjustable stand and wall mount option, providing flexibility in placement to suit any office environment. Its design ensures comfort during use, making it a practical choice for busy professionals.",
      },
      {
        name: "Easy Management with Unified Platform",
        details: "Simplify your operations with Yealink Device Management Platform. The T31G IP Phone supports unified firmware for easy deployment, centralized control, and reduced IT maintenance costs—ideal for SMEs aiming to optimize their IP phone system."
      },
      {
        name: "Advanced Security for Peace of Mind",
        details: "The Yealink T31G is equipped with TLS 1.3 encryption, offering faster and stronger protection for your conversations. The latest V87 upgrade further enhances security, keeping your communications private and secure."
      }

    ],
    related: [20, 19, 18, 17],
    
    fsize: '12px',
    namesizef: '25px',
    namesizeb: '20px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t31g`,
  },
  {
    id: 5,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T31 Entry Level IP Phone in Pakistan",
    metaKeywords: "Yealink SIP-T31, Yealink SIP-T31 IP phone, Yealink SIP-T31 price in Pakistan, entry level IP phone Pakistan, business IP phone Pakistan, VoIP phone Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink SIP-T31 features, Yealink SIP-T31 specifications, Yealink SIP-T31 dealers Pakistan, affordable IP phone Pakistan, Yealink VoIP phones, IP phone for small business Pakistan, Yealink entry level phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t31-entry-level",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t31-entry-level-ip-phone-pakistan',
    image: y5,
    name: "SIP-T31",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Dual-line entry level IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.3” 132x64-pixel graphical LCD
with backlight`,
      `Up to 2 SIP accounts`,
      `PoE support`,
      `Local 5-way conferencing`


    ],
    // Detail page data
    titlename:'Yealink SIP-T31 Entry Level IP Phone in Pakistan',
    titletagline:'',
     titletagline: "Affordable VoIP Solution for Small Businesses",
    block1: {
      image: y5,
      title: "Facilitate Seamless Business Communication with Yealink",
      description: `Looking for a reliable business desk phone that enhances productivity and delivers crystal-clear communication? The Yealink SIP‑T31 Classic IP Phone in Pakistan is your go-to solution. Whether you're upgrading your business phone system or starting fresh, the T31 IP Phone is a smart investment for SMEs across Pakistan.`,
    },
    block2: {
      image: y5,
      title: "Why Choose the Yealink SIP-T31?",
      description: `Looking for an affordable business IP phone in Pakistan? Our VoIP solutions offer smooth and secure communication tailored for small and medium-sized enterprises. Designed with proven quality and durability, these IP phones ensure long-term performance and reliability. They easily integrate into your existing business phone systems, making setup hassle-free and cost-effective. Whether you're upgrading or starting fresh, our IP phones provide a professional communication experience without breaking the budget.`,
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Powerful Performance for Growing Businesses",
        details: "The Yealink T3 Series, including the T31 IP Phone, is powered by an advanced chipset, ensuring faster operation, smoother performance, and more scalability. This classic VoIP phone in Pakistan is perfect for businesses looking to extend communication capabilities without compromising quality."
      },  
      {
        name: "Superior HD Audio with Smart Noise Filtering",
        details: "Enjoy flawless conversations with Yealink's industry-leading audio technology. The T31 features Smart Noise Filtering, eliminating background disturbances and allowing you to focus on what matters—your business communication."
      },
      {
        name: "Elegant Design Meets Practical Functionality",
        details: "Designed by Yealink’s original team, the T31 desk phone combines a classic design with modern ergonomic details for easier, more intuitive use. From its adjustable multi-angle stand to its wall-mountable option, it fits seamlessly into any office setup.",
      },
      {
        name: "Hall Switch Technology",
        details: "The T31 features a hall switch for silent pickup and hang-up, eliminating the popping sounds for a quieter work environment. This makes it ideal for professional environments where discretion is key.",

      },
      {
        name: "Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T31 features an adjustable stand and wall mount option, providing flexibility in placement to suit any office environment. Its design ensures comfort during use, making it a practical choice for busy professionals.",
      },
      {
        name: "Easy Management with Unified Platform",
        details: "Simplify your operations with Yealink Device Management Platform. The T31 IP Phone supports unified firmware for easy deployment, centralized control, and reduced IT maintenance costs—ideal for SMEs aiming to optimize their IP phone system."
      },
      {
        name: "Advanced Security for Peace of Mind",
        details: "The Yealink T31 is equipped with TLS 1.3 encryption, offering faster and stronger protection for your conversations. The latest V87 upgrade further enhances security, keeping your communications private and secure."
      }

    ],
    related: [20, 19, 18, 17],

    fsize: '12px',
    namesizef: '25px',
    isize: '80%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t31`,
  },
  {
    id: 21,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink SIP-T30P IP Phone in Pakistan",
    metaDescription:"Buy the Yealink SIP‑T30P IP Phone in Pakistan. A cost-effective VoIP desk phone with HD audio, PoE support, 3‑line display, and user-friendly telephony features.",
    metaKeywords: "Yealink SIP-T30P, Yealink SIP-T30P IP phone, Yealink SIP-T30P price in Pakistan, entry level IP phone Pakistan, business IP phone Pakistan, VoIP phone Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink SIP-T30P features, Yealink SIP-T30P specifications, Yealink SIP-T30P dealers Pakistan, affordable IP phone Pakistan, Yealink VoIP phones, IP phone for small business Pakistan, Yealink entry level IP phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t30p",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t30p-ip-phone-pakistan',
    image: y21,
    name: "SIP-T30P",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Single line entry level IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.3” 132x64-pixel graphical LCD`,
      `Two-port 10/100M Ethernet
Switch`,

      `PoE support`,
      `One SIP account`,
      `Local 5-way conferencing`,



    ],
    // detail page data
    titlename: "Yealink SIP-T30P IP Phone in Pakistan",
    titletagline: "Affordable VoIP Solution for Small Businesses",
    block1: {
      image: y21,
      title: "Strong Performance, More Possibilities with Yealink T30P",
      description: "Experience seamless business communication with the Yealink SIP‑T30P IP Phone in Pakistan — a powerful corded office phone designed to meet the evolving needs of SMEs. Powered by an advanced chip, the Yealink T30P delivers faster processing, upgraded features, and smooth office performance. Whether you're scaling operations or improving internal communication, this business desk phone is built to support your growth.",
    },
    block2: {
      image: y21,
      title: "Why Choose the Yealink SIP-T30P?",
      description: "The Yealink SIP-T30P IP Phone is a cost-effective solution for small and medium-sized enterprises in Pakistan. It offers reliable performance, HD audio quality, and user-friendly features, making it an ideal choice for businesses looking to improve their communication systems.",
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "HD Audio That Means Business",
        details: "The Yealink T3 Series, including the T30P IP Phone, is powered by an advanced chipset, ensuring faster operation, smoother performance, and more scalability. This classic VoIP phone in Pakistan is perfect for businesses looking to extend communication capabilities without compromising quality."
      },
      {
        name: "Superior HD Audio with Smart Noise Filtering",
        details: "Enjoy flawless conversations with Yealink's industry-leading audio technology. The T30P features Smart Noise Filtering, eliminating background disturbances and allowing you to focus on what matters—your business communication."
      },
      {
        name: "Elegant Design Meets Practical Functionality",
        details: "Designed by Yealink’s original team, the T30P desk phone combines a classic design with modern ergonomic details for easier, more intuitive use. From its adjustable multi-angle stand to its wall-mountable option, it fits seamlessly into any office setup."
      }
      ,
      {
        name: "Hall Switch Technology",
        details: "The T30P features a hall switch for silent pickup and hang-up, eliminating the popping sounds for a quieter work environment. This makes it ideal for professional environments where discretion is key.",

      },
      {
        name: "Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T30P features an adjustable stand and wall mount option, providing flexibility in placement to suit any office environment. Its design ensures comfort during use, making it a practical choice for busy professionals.",
      },
      {
        name: "Centralized Management Made Easy",
        details: "Integrated with the Yealink Device Management Platform, the T30P enables simplified deployment, configuration, and maintenance. Its unified firmware significantly reduces operational costs — perfect for SMEs looking to streamline their communication infrastructure."
      },
      {
        name: "Unbreakable Security for Your Conversations",
        details: "Buy Yealink T30P in Pakistan and enjoy enterprise-grade security with TLS 1.3 encryption, now available in the V87 firmware upgrade. Your voice data stays protected, ensuring trust and compliance for every call."
      }
    ],
    related: [20, 19, 18, 17],

    fsize: '12px',
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t30p`,
  },
  {
    id: 4,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink SIP-T30 IP Phone in Pakistan",
    metaDescription:"Buy the Yealink SIP‑T30 IP Phone in Pakistan. A reliable business VoIP phone with HD audio and 3-line display, perfect for small to medium offices.",
    metaKeywords: "Yealink SIP-T30, Yealink SIP-T30 IP phone, Yealink SIP-T30 price in Pakistan, entry level IP phone Pakistan, business IP phone Pakistan, VoIP phone Pakistan, Yealink IP phones Pakistan, SIP phones Pakistan, Yealink SIP-T30 features, Yealink SIP-T30 specifications, Yealink SIP-T30 dealers Pakistan, affordable IP phone Pakistan, Yealink VoIP phones, IP phone for small business Pakistan, Yealink entry level IP phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "sip-t30",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-sip-t30-ip-phone-pakistan',
    image: y4,
    name: "SIP-T30",
    subtitle: 'T3 Series',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Single line entry level IP phone ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Yealink HD Voice`,
      `2.3” 132x64-pixel graphical LCD`,
      `One SIP account`,
      `PoE support`,
      `Local 5-way conferencing`,



    ],
    // detail page data
    titlename: "Yealink SIP-T30 IP Phone in Pakistan",
    titletagline: "Affordable VoIP Solution for Small Businesses",
    block1: {
      image: y4,
      title: "Facilitate Seamless Business Communication with Yealink",
      description: "Looking for a reliable business desk phone that enhances productivity and delivers crystal-clear communication? The Yealink SIP‑T30 Classic IP Phone in Pakistan is your go-to solution. Whether you're upgrading your business phone system or starting fresh, the T30 IP Phone is a smart investment for SMEs across Pakistan.",
    },
    block2: {
      image: y4,
      title: "Why Choose the Yealink SIP-T30?",
      description: "The Yealink SIP-T30 IP Phone is a cost-effective solution for small and medium-sized enterprises in Pakistan. It offers reliable performance, HD audio quality, and user-friendly features, making it an ideal choice for businesses looking to improve their communication systems.",
    },
    pdfFile: "/pdfFiles/comparison.pdf",
    Detailspagecards: [
      {
        name: "Powerful Performance for Growing Businesses",
        details: "The Yealink T3 Series, including the T30 IP Phone, is powered by an advanced chipset, ensuring faster operation, smoother performance, and more scalability. This classic VoIP phone in Pakistan is perfect for businesses looking to extend communication capabilities without compromising quality."
      },
      {
        name: "Superior HD Audio with Smart Noise Filtering",
        details: "Enjoy flawless conversations with Yealink's industry-leading audio technology. The T30 features Smart Noise Filtering, eliminating background disturbances and allowing you to focus on what matters—your business communication."
      },
      {
        name: "Elegant Design Meets Practical Functionality",
        details: "Designed by Yealink’s original team, the T30 desk phone combines a classic design with modern ergonomic details for easier, more intuitive use. From its adjustable multi-angle stand to its wall-mountable option, it fits seamlessly into any office setup.",
      },
      {
        name: "Hall Switch Technology",
        details: "The T30 features a hall switch for silent pickup and hang-up, eliminating the popping sounds for a quieter work environment. This makes it ideal for professional environments where discretion is key.",

      },
      {
        name: "Adjustable Stand and Wall Mount Option",
        details: "The Yealink SIP-T30 features an adjustable stand and wall mount option, providing flexibility in placement to suit any office environment. Its design ensures comfort during use, making it a practical choice for busy professionals.",
      },
      {
        name: "Easy Management with Unified Platform",
        details: "Simplify your operations with Yealink Device Management Platform. The T30 IP Phone supports unified firmware for easy deployment, centralized control, and reduced IT maintenance costs—ideal for SMEs aiming to optimize their IP phone system."
      },
      {
        name: "Advanced Security for Peace of Mind",
        details: "The Yealink T30 is equipped with TLS 1.3 encryption, offering faster and stronger protection for your conversations. The latest V87 upgrade further enhances security, keeping your communications private and secure."
      }
    ],
    related: [20, 19, 18, 17],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '80%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/ip-phone-t30`,
  },
  {
    id: 3,
    title: "IP Phones",
    // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp965-flagship-hd",
    company: "yealink",
    productType: "ip",
    country: "pakistan",
    permalink:'yealink-cp965-flagship-hd-ip-phone-pakistan',
    image: y3,
    name: "CP965",
    subtitle: 'Conference Phone',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Flagship conference phone for medium to large rooms and for best-in-class audio conferencing.',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Android 9.0`,
      `5-inch multi-touch screen with
720x1280 resolution`,
      `20-foot and 360-degree voice
pickup`,
      `Built-in 12-microphone array for
voice pickup`,
      `Built-in 1-microphone array for
noise cancellation`,
      `10-way conference call`,
      `Hybrid UC meeting`,
      `Built-in Bluetooth and Wi-Fi`,


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '10px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/conference-phone-cp965`,
  },


  {
    id: 2,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink CP935W‑Base Wireless Conference Phone in Pakistan – Premium Audio Meetings",
    metaDescription:"Buy the Yealink CP935W‑Base Wireless Conference Phone in Pakistan. Featuring crystal-clear HD audio, 5‑way conferencing, full duplex, and cordless flexibility with long-life battery.",
    metaKeywords: "Yealink CP935W‑Base Wireless Conference Phone in Pakistan, Buy Yealink CP935W Pakistan, CP935W Conference Phone Price, Wireless Conference Phone Pakistan, HD Audio Meeting Phone, Yealink CP935W Features",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp935w-base-wireless",
    company: "yealink",
    productType: "conference-phone",
    country: "pakistan",
    permalink:'yealink-cp935w-base-wireless-conference-phone-pakistan',
    image: y2,
    name: "CP935W",
    subtitle: 'Conference Phone',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Wireless Wi-Fi Touch-Sensitive Conference Phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`4-inch multi-touch screen with
480x800 resolution`,
      `Built-in rechargeable lithium
battery`,
      `Up to 15 hours talk time`,
      `Up to 75 hours standby time in
Wi-Fi mode`,
      `20-foot and 360° voice pickup`,
      `Built-in 6-microphone array for
voice pickup`,
      `5-way conference call`,
      `Built-in Bluetooth and Wi-Fi`,


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '10px',
    isize: '90%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/conference-phone-cp935w`,
  },
  {
    id: 1,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink CP925 HD IP Conference Phone in Pakistan  – Premium Audio Conferencing",
    metaDescription:"Buy the Yealink CP925 HD IP Conference Phone in Pakistan. Offers HD full‑duplex audio, expandable speaker capacity, built‑in Wi‑Fi/Bluetooth, and seamless integration for clear meetings.",
    metaKeywords: "Offers HD full‑duplex audio, expandable speaker capacity, built‑in Wi‑Fi/Bluetooth, and seamless integration for clear meetings.",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp925-hd",
    company: "yealink",
    productType: "conference-phone",
    country: "pakistan",
    permalink:'yealink-cp925-hd-conference-phone-pakistan',
    image: y1,
    name: "CP925",
    subtitle: 'Conference Phone',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'CP925 HD IP conference phone for small to medium conference rooms',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`4-inch multi-touch screen with
480x800 resolution`,
      `20-foot and 360-degree voice
pickup`,
      `Built-in 6-microphone array for
voice pickup`,
      `Built-in 1-microphone array for
noise cancellation`,
      `5-way conference call`,
      `Built-in Wi-Fi and Bluetooth`,
      `Local 3-way PSTN conference
via Yealink CPN10`,


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '10px',
    isize: '90%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/conference-phone-cp925`,
  },

  {
    id: 27,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink BT41 Bluetooth 4.1 Adapter for IP Phone in Pakistan – Wireless Expansion",
    metaDescription:"Buy the Yealink BT41 Bluetooth 4.1 Adapter for IP Phone in Pakistan. Add wireless headset connectivity and improved device flexibility—compatible with Yealink SIP phones.",
    metaKeywords: "Yealink BT41 Bluetooth 4.1 Adapter Pakistan, Buy Yealink BT41 Pakistan, BT41 IP Phone Bluetooth Adapter, Wireless Headset Adapter Pakistan, Yealink Bluetooth Accessory",
    // peramlink: "company-linkname-producttype-country",
    linkname: "bt41-bluetooth-4.1-bluetooth-adapter-for",
    company: "yealink",
    productType: "ip-phone",
    country: "pakistan",
    permalink:'yealink-bt41-bluetooth-4.1-adapter-ip-phone-pakistan',
    image: y27,
    name: "BT41",
    subtitle: 'Phone Accessories',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Bluetooth USB dongle',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Bluetooth specification: V4.1`,
      `Support 8K NBS (apply to SIP-
                T27G/T29G/T46G/T48G/T41S/T42S/
                T46S/T48S)`,
      `Support 16K WBS (apply to
                T42U/T43U/T44U/T46U/T48U/T53)`,
      `Operating distance: 10 meters`,
      `Answer incoming calls through
                Bluetooth headset`,
      `Adjusts the volume of Bluetooth
                headset through Bluetooth headset
                or your phone`


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '10px',
    isize: '90%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/accessories-bt41`,
  },


  {
    id: 28,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink CAM50 2 MP HD Camera for T58V & T58A in Pakistan – Superior Video Quality",
    metaDescription:"Buy the Yealink CAM50 2 MP HD Camera for T58V & T58A in Pakistan. Enjoy sharp video conferencing, plug-and-play USB-C, and seamless integration with your Yealink IP phone.",
    metaKeywords: "Yealink CAM50 HD Camera Pakistan, Buy Yealink CAM50 Pakistan, CAM50 IP Phone Camera, HD Video Camera for Yealink Phones, Yealink CAM50 Features, Yealink CAM50 Price",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cam50-2mega-pixel-hd-camera-for",
    company: "yealink",
    productType: "t58v-&-t58a",
    country: "pakistan",
    permalink:'yealink-cam50-2mega-pixel-hd-camera-t58v-t58a-pakistan',
    image: y28,
    name: "CAM50 ",
    subtitle: 'Phone Accessories',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'HD camera for SIP-T58W ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [`Compatible with Yealink SIP-
T58W/SIP-T58A IP Phones`,
      `5 mega-pixel HD Camera`,
      `720p@30fps`,
      `Ease-of-use`,
      `Plug and Play`,
      `Adjustable with privacy shutter`


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/accessories-cam50`,
  },
  {
    id: 29,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink CPN10 PSTN Box Accessories in Pakistan – Reliable Telephony Extension",
    metaDescription:"Buy the Yealink CPN10 PSTN Box accessory in Pakistan. Expand your Yealink IP phone system with analog PSTN integration—easy setup and enhanced flexibility.",
    metaKeywords: "Yealink CPN10 Pakistan, CPN10 PSTN Box, Yealink PSTN accessory Pakistan, PSTN integration IP phone, Yealink CPN10 features, Yealink telephony accessory",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cpn10-pstn",
    company: "yealink",
    productType: "box-accessories",
    country: "pakistan",
    permalink:'yealink-cpn10-pstn-box-accessories-pakistan',
    image: y29,
    name: "CPN10",
    subtitle: 'Phone Accessories',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'PSTN box',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [
      `Support Yealink IP Conference
Phone CP860/CP920/CP925/CP965/ T67LTE/ VP59/ T58A/ T58W/ T57W/ T54W/ T53W/ T53`,
      `Plug and play`,
      `USB call recording`,
      `Support up to 2 cascaded
CPN10 to setup PSTN
conference`


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '90%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/accessories-cpn10`,
  },
  {
    id: 31,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink EXP50 Color‑screen Expansion Module in Pakistan – Enhance IP Phone Functionality",
    metaDescription:"Buy the Yealink EXP50 color‑screen expansion module in Pakistan. Extend your Yealink IP phone with a 4.3″ display for additional programmable keys and improved call handling.",
    metaKeywords: "Yealink EXP50 Pakistan, EXP50 expansion module, Yealink EXP50 Pakistan price, Color screen Module for Yealink, IP phone expansion accessory, Yealink EXP50 features",
    // peramlink: "company-linkname-producttype-country",
    linkname: "exp50-color-screen",
    company: "yealink",
    productType: "expansion-module",
    country: "pakistan",
    permalink:'yealink-exp50-color-screen-expansion-module-pakistan',
    image: y31,
    name: "EXP50",
    subtitle: 'Phone Accessories',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Color-screen expansion module',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [
      `4.3" 272 x 480-pixel color screen`,
      `Color icons for rich visual
                experience`,
      `20 physical keys on each page
                with dual-color LEDs`,
      `Three independent control keys
                with illuminated LED for fast
                switching pages`,
      `Supports up to 3 modules daisy-
                chain`,
      `Stand with 2 adjustable angles`,


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '10px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/accessories-exp50`,
  },
  {
    id: 32,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink EXP43 Color Expansion Module in Pakistan – Enhance IP Phone Capability",
    metaDescription:"Buy the Yealink EXP43 color expansion module in Pakistan. Add a vibrant secondary display with programmable keys to boost productivity and call management.",
    metaKeywords: "Yealink EXP43 Pakistan, EXP43 expansion module, color expansion module, Yealink EXP43 price, IP phone accessory Pakistan, Yealink EXP43 features",
    // peramlink: "company-linkname-producttype-country",
    linkname: "exp43-color",
    company: "yealink",
    productType: "expansion-module",
    country: "pakistan",
    permalink:'yealink-exp43-color-expansion-module-pakistan',
    image: y32,
    name: "EXP43",
    subtitle: 'Phone Accessories',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Color Expansion Module ',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [
      `User-friendly Structure Design`,
      `Intuitive Visualization`,
      `High Expansibility`,


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/accessories-exp43`,
  },


  {
    id: 30,
    title: "IP Phones",
     // meta tags for SEO data
    metaTitle: "Yealink AX83H Business Wi‑Fi Handset in Pakistan – Portable Office Phone",
    metaDescription:"Buy the Yealink AX83H Business Wi‑Fi Handset in Pakistan. Enjoy mobile office communication with HD voice, dual Wi‑Fi bands, and seamless integration with Yealink phone systems.",
    metaKeywords: "Yealink AX83H Pakistan, AX83H Wi‑Fi Handset, Business Wi‑Fi Phone Pakistan, Yealink AX83H features, Portable office handset, Yealink wireless handset",
    // peramlink: "company-linkname-producttype-country",
    linkname: "ax83h-business",
    company: "yealink",
    productType: "wifi-handset",
    country: "pakistan",
    permalink:'yealink-ax83h-business-wifi-handset-pakistan',
    image: y30,
    name: "AX83H",
    subtitle: 'Wi-Fi Handset',
    colors: 'linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)',
    details: 'Business Wi-Fi Cordless IP Phone',
    types: [`Lorem `, `Lorem `, `Lorem `],
    backDetails: [
      `Dual-Band Wi-Fi 6 with seamless
802.11k/v/r roaming`,
      `HD Voice and Smart Noise
Filtering`,
      `Wireless headsets connection via
Bluetooth 5.0`,
      `2.4-inch 240 x 320 TFT color
screen`,
      `4 SIP accounts,5-way
conference`


    ],
    namesizef: '25px',
    namesizeb: '20px',
    fsize: '12px',
    isize: '100%',
    bsize: '0px',
    weblink: `https://www.yealink.com/en/product-detail/yealink-ax83h-business-wi-fi-handset`,
  },

  {
    id: 33,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "Meeting Bar A40 Microsoft Teams Rooms on Android",
    details: "All-in-one video meeting bar for premium medium rooms",
     // meta tags for SEO data
    metaTitle: "Yealink Meeting Bar A40 in Pakistan – Premium Video Conferencing Solution",
    metaDescription: "Buy the Yealink Meeting Bar A40 in Pakistan. Experience ultra HD video quality and high-quality audio pickup for seamless meetings.",
    metaKeywords: "Yealink Meeting Bar A40 Pakistan, Meeting Bar A40 price, Yealink video conferencing, Meeting Bar A40 features",
    permalink: "yealink-meeting-bar-a40-microsoft-teams-rooms-on-android",
    image: y33,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Ultra HD picture quality*",
      "High-quality audio pickup experience*",
      "Compatible with Microsoft's MDEP",
      "Multi-Platform Flexibility",
      "Simple deployment",
      "Remote device management"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "60%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-meetingbar-a40"
  },
  {
    id: 34,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "Meeting Board Microsoft Teams Rooms on Android",
    details: "All-In-One Video Conferencing Device with Interactive Whiteboard",
      // meta tags for SEO data
    metaTitle: "Yealink Meeting Board in Pakistan – All-in-One Video Conferencing Solution",
    metaDescription: "Buy the Yealink Meeting Board in Pakistan. Enjoy an all-in-one design with a 4K camera, dual-screen support, and Microsoft Teams & Zoom certification.",
    metaKeywords: "Yealink Meeting Board Pakistan, Meeting Board price, Yealink video conferencing",
    permalink: "yealink-meeting-board-microsoft-teams-rooms-on-android",
    image: y34,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "ALL-IN-ONE design",
      "Android 10",
      "4K built-in camera",
      "Detachable optional PTZ camera for larger space",
      "Dual-screen supported",
      "WIFI6 wireless presentation",
      "Windows OPS Module",
      "Microsoft Teams & Zoom certified"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-meetingboard65"
  },
  {
    id: 35,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "MVC S40 Microsoft Teams Rooms on Windows",
    details: "Video Conferencing System for Medium Rooms",
      // meta tags for SEO data
    metaTitle: "Yealink Meeting Bar A40 in Pakistan – Premium Video Conferencing Solution",
    metaDescription: "Buy the Yealink Meeting Bar A40 in Pakistan. Experience ultra HD video quality and high-quality audio pickup for seamless meetings.",
    metaKeywords: "Yealink Meeting Bar A40 Pakistan, Meeting Bar A40 price, Yealink video conferencing, Meeting Bar A40 features",
    // peramlink: "company-linkname-producttype-country",     
    permalink: "yealink-mvc-s40-microsoft-teams-rooms-on-windows",
    image: y35,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Smart Vision 40, All-in-One video bar",
      "M Core Pro Mini PC",
      "MTouch E2 Touch Panel",
      "2x 48 MP Camera",
      "Support Intelli Focus",
      "Support Multi-Stream Intelli Frame (Microsoft Teams)",
      "Support Video Fence",
      "Support 2x expansion microphone"
    ],
    namesizef: "18px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvcs40"
  },

  {
    id: 36,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "MVC S60 Microsoft Teams Rooms on Windows",
    details: "Video Conferencing System with 360-degree all-in-one Camera for Medium Rooms",
     // meta tags for SEO data
    metaTitle: "Yealink Meeting Bar A40 in Pakistan – Premium Video Conferencing Solution",
    metaDescription: "Buy the Yealink Meeting Bar A40 in Pakistan. Experience ultra HD video quality and high-quality audio pickup for seamless meetings.",
    metaKeywords: "Yealink Meeting Bar A40 Pakistan, Meeting Bar A40 price, Yealink video conferencing, Meeting Bar A40 features",
    // peramlink: "company-linkname-producttype-country",
    permalink: "yealink-mvc-s60-microsoft-teams-rooms-on-windows",
    image: y36,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "HFOV: 360° Camera",
      "M Core Pro, Gen-3 Mini-PC",
      "MTouch Plus, Gen-3 touch panel",
      "Smart Vision 60, All-in-One video bar",
      "11.6-inch narrow bezel IPS display",
      "1920 x 1080 video resolution",
      "2 x Microphone Mute/Unmute button",
      "Memory: 8 GB (2 x 4GB)"
    ],
    namesizef: "18px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvcs60"
  },
  {
    id: 37,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "MVC S90 Microsoft Teams Rooms on Windows",
    details: "Video Conferencing System for Pro-AV Rooms",
      // meta tags for SEO data
    metaTitle: "Yealink Meeting Bar A40 in Pakistan – Premium Video Conferencing Solution",
    metaDescription: "Buy the Yealink Meeting Bar A40 in Pakistan. Experience ultra HD  video quality and high-quality audio pickup for seamless meetings.",
    metaKeywords: "Yealink Meeting Bar A40 Pakistan, Meeting Bar A40 price, Yealink video conferencing, Meeting Bar A40 features",
    // peramlink: "company-linkname-producttype-country",
    permalink: "yealink-mvc-s90-microsoft-teams-rooms-on-windows",
    image: y37,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "2 x UVC86 USB PTZ camera",
      "M Core Pro, Gen-3 Mini-PC",
      "MTouch Plus, Gen-3 touch panel",
      "AV Hub, audio and video processor",
      "Room Sensor, meeting room sensor",
      "Memory: 8 GB (2 x 4GB)",
      "11.6-inch narrow bezel IPS display",
      "20.4 × HD zoom (12x optical, 1.7x digital)"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvcs90"
  },
  {
    id: 38,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "MVC940 Microsoft Teams Rooms on Windows",
    details: "Video Conferencing System for Extra-Large Rooms",
      // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country", 
    permalink: "yealink-mvc940-microsoft-teams-rooms-on-windows",
    image: y38,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "2 x UVC84 USB PTZ Camera",
      "M Core Pro, Gen-3 Mini-PC",
      "M Touch Plus, Gen-3 touch panel",
      "AV Hub, audio and video processor",
      "2 x WPP30 wireless presentation pod (Optional)",
      "Room Sensor, meeting room sensor",
      "11.6-inch narrow bezel IPS display",
      "12x optical zoom PTZ camera"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvc940-iii"
  },


  {
    id: 39,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "MVC860 Microsoft Teams Rooms on Windows",
    details: "Video Conferencing System for Large Rooms",
      // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
    permalink: "yealink-mvc860-microsoft-teams-rooms-on-windows",
    image: y39,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "UVC86 USB PTZ camera",
      "Room Sensor",
      "M Speaker II (optional)",
      "VCM35 Array microphone (optional)",
      "VCM36-W Wi-Fi wireless microphone (optional)",
      "VCM38 Ceiling array microphone (optional)",
      "WPP30 wireless presentation pod (optional)",
      "20.4 × HD zoom (12x optical, 1.7x digital) PTZ Camera"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "10px",
    isize: "60%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvc860-iii"
  },
  {
    id: 40,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "MVC640 Microsoft Teams Rooms on Windows",
    details: "Video Conferencing System for Medium Rooms",
     // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
      linkname: "cp965-flagship-hd",
      company: "yealink",
      productType: "ip",
      country: "pakistan",
    permalink: "yealink-mvc640-microsoft-teams-rooms-on-windows",
    image: y40,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "UVC84 USB PTZ camera",
      "M Speaker II (optional)",
      "CPW65 DECT wireless microphone (optional)",
      "VCM36-W Wi-Fi wireless microphone (optional)",
      "WPP30 wireless presentation pod (optional)",
      "Memory: 8 GB (2 x 4GB)",
      "8-inch IPS screen",
      "12x optical zoom USB PTZ camera"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvc640-iii"
  },
  {
    id: 41,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: " MVC340 Microsoft Teams Rooms on Windows",
     // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp965-flagship-hd",
    company: "yealink",
    productType: "ip",
    country: "pakistan",
    permalink: "yealink-mvc340-microsoft-teams-rooms-on-windows",
    details: "Video Conferencing System for Focus and Small Rooms",
    image: y41,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "UVC34 All-in-One Video Bar",
      "11th Gen Intel® Core i5",
      "Memory: 8 GB (2 x 4GB)",
      "8-inch IPS screen",
      "1280 x 800 resolution",
      "8 MP Camera",
      "5x e-PTZ Camera"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "9px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-mvc340-iii"
  },
  {
    id: 42,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "Meeting Bar A20 Microsoft Teams Rooms on Android",
    details: "All-in-One Video Bar for Premium Small Rooms",
     // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp965-flagship-hd",
    company: "yealink",
    productType: "ip",
    country: "pakistan",
    permalink: "yealink-meeting-bar-a20-microsoft-teams-rooms-on-android",
    image: y42,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design",
      "20MP Camera",
      "120° Field of View",
      "Dual Screen",
      "Auto Framing and Speaker Tracking",
      "Built-in Dual-band Wi-Fi",
      "Content Sharing",
      "Certified by Microsoft Teams, Zoom, Blue Jeans, and RingCentral"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-meetingbar-a20"
  },

  {
    id: 43,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "Meeting Bar A30 Microsoft Teams Rooms on Android",

    details: "All-in-One Video Conference Bar for Medium Rooms",
     // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp965-flagship-hd",
    company: "yealink",
    productType: "ip",
    country: "pakistan",
    permalink: "yealink-meeting-bar-a30-microsoft-teams-rooms-on-android",
    image: y43,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design",
      "Two Cameras Design",
      "120° Field of View",
      "Dual Screen",
      "Auto Framing and Speaker Tracking",
      "Built-in Dual-band Wi-Fi",
      "Content Sharing",
      "Certified by Microsoft Teams, Zoom, Blue Jeans, and RingCentral"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "60%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-meetingbar-a30"
  },
  {
    id: 44,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: "Meeting Bar A10 Microsoft Teams Rooms on Android",
    details: "For Small Spaces and Home Offices",
     // meta tags for SEO data
    metaTitle: "Yealink CP965 Flagship HD IP Phone in Pakistan – Premium Conference Call Solution",
    metaDescription:"Buy the Yealink CP965 Flagship HD IP Phone in Pakistan. Enjoy 20-meter voice pickup, excellent HD audio, built-in Wi‑Fi/Bluetooth, and crystal-clear conference performance.",
    metaKeywords: "Yealink CP965 Flagship HD IP Phone in Pakistan, Buy Yealink CP965 Pakistan, CP965 IP Phone Price, HD Conference Phone Pakistan, Yealink CP965 Features, Business Conference Phone",
    // peramlink: "company-linkname-producttype-country",
    linkname: "cp965-flagship-hd",
    company: "yealink",
    productType: "ip",
    country: "pakistan",
    permalink: "yealink-meeting-bar-a10-microsoft-teams-rooms-on-android",
    image: y44,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design",
      "4K Camera",
      "Electric Privacy Shutter",
      "Auto Framing and Speaker Tracking",
      "Built-in Wi-Fi & Bluetooth",
      "Content Sharing",
      "Certified by Microsoft Teams, Zoom, and RingCentral"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "60%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-meetingbar-a10"
  },
  {
    id: 45,
    title: "Microsoft & Zoom Devices",
    subtitle: "Team Room System",
    name: " Desk Vision A24 Microsoft Teams Room on Android",
    details: "For Desk / Phone Rooms",
    permalink: "yealink-desk-vision-a24-microsoft-teams-room-on-android",
    image: y45,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Teams/Zoom Display Certified",
      "UC Workstation Mode",
      "Full-HD Video Call",
      "High-Quality Microphone and Speakers",
      "USB Docking Station"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-rooms-deskvision-a24"
  },

  {
    id: 46,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Meeting Bar A40 Zoom Rooms Appliances",
    details: "All-in-one video bar for premium small to medium rooms",
    permalink: "yealink-meeting-bar-a40-zoom-rooms-appliances",
    image: y46,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Maximum pixels: 2 x 48MP pixels",
      "Number of preset positions: 9",
      "Electronic gimbal",
      "120° DFOV, 54° VFOV, 110° HFOV",
      "Depth of field: 1-5 meters",
      "6x digital zoom",
      "Maximum resolution: 4K",
      "Maximum frame rate: 60FPS",
      "Intelligence Features: Intelli Focus, Auto Framing, Speaker Tracking",
      "Built-in 2 x 10W speakers",
      "Built-in 8 MEMS microphone array"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "9px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-meetingbar-a40"
  },
  {
    id: 47,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "ZVC S90 Zoom Rooms Systems",
    details: "Video Conferencing System for Pro-AV Rooms",
    permalink: "yealink-zvc-s90-zoom-rooms-systems-pak",
    image: y47,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "4K Sensor USB PTZ Camera",
      "20.4 × HD zoom (12x optical, 1.7x digital) USB PTZ Camera",
      "M Core Pro, Gen-3 Mini-PC",
      "MTouch Plus, Gen-3 touch panel",
      "AV Hub, audio and video processor",
      "11th Gen Intel® Core i5",
      "Memory: 8 GB (2 x 4GB)",
      "Storage: 128 GB SSD",
      "11.6-inch narrow bezel IPS display",
      "1920 x 1080 video resolution",
      "Auto-framing",

    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "9px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-zvcs90-iii"
  },
  {
    id: 48,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "ZVC860 Zoom Rooms Systems",
    details: "Video Conferencing System for Large Rooms",
    image: y48,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "UVC86 USB PTZ camera",
      "M Core Pro, Gen-3 Mini-PC",
      "MTouch Plus, Gen-3 touch panel",
      "Windows 11 IoT Enterprise X64",
      "Windows 11 IoT Enterprise License",
      "11th Gen Intel® Core i5",
      "Memory: 8 GB (2 x 4GB)",
      "1.6-inch narrow bezel IPS display",
      "20.4 × HD zoom (12x optical, 1.7x digital) PTZ Camera"
    ],
    namesizef: "19px",
    namesizeb: "12px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-zvc860-iii"
  },


  {
    id: 49,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Meeting Board Zoom Rooms Appliance",
    details: "All-In-One Intelligent Whiteboard for Meeting Room",
    image: y49,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "ALL-IN-ONE design",
      "Android 10",
      "4K built-in camera",
      "Detachable optional PTZ camera for larger space",
      "Extended wireless microphones",
      "Windows OPS Module",
      "Upgradeable Android OPS Module",
      "Teams / Zoom Whiteboard",
      "Microsoft Teams & Zoom certified"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-meetingboard65"
  },
  {
    id: 50,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "MCoreKit-C5-ZR (Base-kit)",
    details: "Video Conferencing System for Diverse Rooms",
    image: y50,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "M Core Pro, Gen-3 Mini-PC",
      "11th Gen Intel® Core i5",
      "Memory: 8 GB (2 x 4GB)",
      "Storage: 128 GB SSD",
      "3x HDMI video output with CEC supported",
      "MTouch Plus, Gen-3 touch panel",
      "11.6-inch narrow bezel IPS display",
      "1920 x 1080 video resolution",
      "Support multi-screen control*",
      "Support third-party screen sharing*",
      "Room Sensor",
      "Detection angle: 120°",
      "Adjustable detection angle: ±20°",
      "Operating temperature: 0-40℃",
      "Operating humidity: 10-95%"
    ],
    namesizef: "20px",
    namesizeb: "11px",
    fsize: "8px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-mcorekitc5zr-iii"
  },
  {
    id: 51,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: " Meeting Eye 500",
    details: "A Mini-PC for Multi-Camera Solution in Zoom Rooms System on Android",
    image: y51,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Smart Experience",
      "3 x HDMI out port",
      "1 x VCH/LAN",
      "1 x HDMI in Port",
      "3 x USB-A 3.0"
    ],
    namesizef: "23px",
    namesizeb: "17px",
    fsize: "12px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-kits-meetingeye500"
  },
  {
    id: 52,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Desk Vision A24 Zoom Rooms Appliance",
    details: "Desktop Collaboration Display",
    image: y52,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Teams/Zoom Display Certified",
      "UC Workstation Mode",
      "Full-HD Video Call",
      "High quality microphone and speakers",
      "USB Docking Station",
      "USB Power Delivery for PC",
      "QI Wireless Charging",
      "Teams Room Android Certified"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-deskvision-a24"
  },




  {
    id: 53,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Meeting Bar A10 Zoom Rooms Appliances",
    details: "For small space and home office",
    image: y53,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design",
      "4K Camera",
      "Auto Framing and Speaker Tracking",
      "Built-in Wi-Fi & Bluetooth",
      "Content Sharing",
      "Certified by Microsoft Teams & Zoom"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "60%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-meetingbar-a10"
  },
  {
    id: 54,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Meeting Bar A20 Zoom Rooms Appliances",
    details: "All-in-one video bar for premium small rooms",
    image: y54,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design",
      "20MP Camera",
      "120° Field of View",
      "Dual Screen",
      "Auto Framing and Speaker Tracking",
      "Built-in Dual-band Wi-Fi",
      "Content Sharing",
      "Certified by Microsoft Teams & Zoom & Blue Jeans & RingCentral"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-meetingbar-a20"
  },
  {
    id: 55,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Meeting Bar A30 Zoom Rooms Appliances",
    details: "All-in-one video bar for medium rooms",
    image: y55,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design",
      "Two Cameras Design",
      "120° Field of View",
      "Dual Screen",
      "Auto Framing and Speaker Tracking",
      "Built-in Dual-band Wi-Fi",
      "Content Sharing",
      "Certified by Microsoft Teams & Zoom & Blue Jeans & RingCentral"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-meetingbar-a30"
  },
  {
    id: 56,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Room Cast for Zoom Rooms",
    details: "Digital Signage & Wireless Presentation System",
    image: y56,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Zoom Digital Signage",
      "Yealink Wireless Presentation Pod",
      "Air Play",
      "Zoom Direct Sharing",
      "Zoom Sharing Key",
      "4-Screen Casting",
      "Remote device management",
      "AES 128 data encryption"
    ],
    namesizef: "20px",
    namesizeb: "12px",
    fsize: "11px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-roomcast"
  },
  {
    id: 57,
    title: "Microsoft & Zoom Devices",
    subtitle: "Zoom Room System",
    name: "Yealink ZVC860 (Base-kit) Zoom Rooms Systems",
    details: "Video Conferencing System for Large Rooms",
    image: y57,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "M Core Pro, Gen-3 Mini-PC",
      "M Touch Plus, Gen-3 touch panel",
      "UVC86 USB PTZ camera",
      "Room Sensor"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-zvc860basekit-iii"
  },



  {
    id: 58,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC85-BYOD",
    details: "Premium Audio and Video Conferencing Solution for Medium to Large Meeting Rooms",
    image: y58,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "36x HD Zoom, 90° Wide-Angle Lens",
      "Audio and Video Integration",
      "Auto-Framing, Efficient Meetings",
      "Flexible Installation, Easy Deployment",
      "Device Management"
    ],
    namesizef: "25px",
    namesizeb: "13px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/uvc85-byod"
  },
  {
    id: 59,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC40 E2",
    details: "All-in-One Intelligent USB Video Bar for Small and Huddle Rooms",
    image: y59,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Ultra-HD 4K Camera | Super-Wide 120° Field of View | Smart Area Exposure",
      "Smart Video Conferencing with AI Technology",
      "Precise Sound Localization, Full-Duplex Experience",
      "Secure Conference with Electric Lens Cap",
      "Integrated Design | Standard UAC/UVC Devices | Device Management"
    ],
    namesizef: "26px",
    namesizeb: "13px",
    fsize: "11px",
    isize: "60%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/uvc40-e2"
  },
  {
    id: 60,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "Smart Vision 40",
    details: "Intelligent All-in-One Camera for Small-to-Medium Microsoft Teams Rooms",
    image: y60,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "2× 48MP",
      "Built-in 8 MEMS Microphone Array",
      "6-Meter Voice Pickup Range",
      "4-Meter Quality Voice Pickup Range",
      "Support 2x Expansion Microphone",
      "Intelli Focus",
      "Auto Framing",
      "Speaker Tracking"
    ],
    namesizef: "23px",
    namesizeb: "13px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/smartvision40"
  },
  {
    id: 61,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "Yealink Smart Vision 60",
    details: "Intelligent 360° All-in-One Camera for Small-to-Medium Microsoft Teams Rooms",
    image: y61,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "360° HFOV, 60° VFOV Camera",
      "10K Panoramic Camera",
      "6 x MEMS Microphone Array",
      "People Feed",
      "Cortana Voice Assistant",
      "Phonetic Transcription",
      "Automatic Translation",
      "Participant Identification"
    ],
    namesizef: "21px",
    namesizeb: "13px",
    fsize: "11px",
    isize: "60%",
    bsize: "5px",
    weblink: "https://www.yealink.com/en/product-detail/smartvision60"
  },

  {
    id: 62,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC86",
    details: "4K Dual-Eye Intelligent Tracking Camera",
    image: y62,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "PTZ Camera: 8MP, Sony Sensor, 90° DFOV, 81° HFOV, 50° VFOV, 20.4x HD Zoom, Pan: ±100°, Tilt: +40°, -90°, 9 Camera Presets",
      "Panoramic Camera: 8MP, Sony Sensor, 120° DFOV, 110° HFOV, 78° VFOV, Manual Tilt: ±9°",
      "Auto Framing",
      "Speaker Tracking",
      "Presenter Tracking"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "12px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/compatible-camera-uvc86"
  },
  {
    id: 63,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC84",
    details: "4K USB PTZ Camera",
    image: y63,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "4K Sensor",
      "80° Field of View",
      "36x HD Zoom (12x Optical + 3x Digital)",
      "Auto Framing",
      "60FPS",
      "Video Output: 4K, 1080p, 720p"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "12px",
    isize: "60%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/compatible-camera-uvc84"
  },
  {
    id: 64,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC34",
    details: "All-in-One USB Video Bar",
    image: y64,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Ultra HD 4K Camera with 1/2.8-Inch CMOS",
      "120° Super-Wide-Angle Lens",
      "Electric Lens Cap",
      "5m Voice Pickup Range",
      "Auto Framing and AI Face Enhancement",
      "Built-in Wi-Fi, Remote Device Management",
      "Applicable to Most Popular Video Conferencing Platforms"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "12px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/compatible-usb-videobar-uvc34"
  },
  {
    id: 65,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC30 Room",
    details: "4K USB Camera",
    image: y65,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "USB Camera",
      "4K Resolution",
      "120° Field of View",
      "Auto Framing",
      "30FPS",
      "Wide Dynamic Range"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "12px",
    isize: "60%",
    bsize: "10px",
    weblink: "https://www.yealink.com/en/product-detail/camera-uvc30-room"
  },

  {
    id: 66,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC84-BYOD",
    details: "For Medium and Large Rooms",
    image: y66,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "4K Video at 30 FPS",
      "12x Optical Zoom, 3x Digital Zoom for Crystal-Clear Video",
      "Mechanical Pan, Tilt, and Zoom",
      "Auto Framing Feature",
      "Smooth PTZ Control via Remote or Yealink Camera Control Plug-In",
      "Long Endurance with BYOD Box",
      "Easy to Deploy"
    ],
    namesizef: "25px",
    namesizeb: "15px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/compatible-camera-byod-uvc84"
  },
  {
    id: 67,
    title: "Microsoft & Zoom Devices",
    subtitle: "USB Cameras & BYOD Kits",
    name: "UVC30-CP900-BYOD",
    details: "For Small and Huddle Conference Rooms",
    image: y67,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "All-in-One Design, Plug and Play",
      "Long Endurance",
      "Cost-Effective",
      "Simple Deployment"
    ],
    namesizef: "20px",
    namesizeb: "12px",
    fsize: "12px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/compatible-usb-byod-uvc30-cp900"
  },
  {
    id: 68,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Panel Zoom Rooms Scheduling Display",
    details: "Enhance Your Room Booking Experience with Zoom Rooms",
    image: y68,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Operating System: Android 10",
      "Display: 8\" LCD Panel, Resolution: 1280x800",
      "Audio: 2x Array Microphones, 2x Watt Speakers",
      "12V Power Adapter",
      "Mounting Options: Surface mount for 2-gang US electrical box, 20° tilt mount kit for wall or glass, Flush mount kit for wall or glass",
      "Bluetooth 5.0, 802.11ac Wi-Fi"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/zoom-rooms-roompanel"
  },
  {
    id: 69,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Panel Microsoft Teams Panels",
    details: "Intelligent Room Scheduling Solution for Your Workspace",
    image: y69,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Display: 8\" LCD Panel, Resolution: 1280x800",
      "Audio: 2x Array Microphones, 2x Watt Speakers",
      "12V Power Adapter",
      "Mounting Options: Surface mount for 2-gang US electrical box, 20° tilt mount kit for wall or glass, Flush mount kit for wall or glass",
      "Bluetooth 5.0, 802.11ac Wi-Fi"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/microsoft-teams-roompanel"
  },
  {
    id: 70,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Sensor Pro",
    details: "Enterprise Multifunctional Room Sensor",
    image: y70,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "People Counting: Detection Range: Radius 4m Circular Area (Height: 3m), Detection Distance: ≤5m",
      "Temperature: Range: 0°C~40°C, Resolution: 0.1°C, Accuracy: -1~+3°C",
      "Humidity: Range: 10~95% RH, Resolution: 0.5% RH, Accuracy: ±5%",
      "Illuminance: Multiple Ranges (up to 20000lux), Accuracy: ±10%"
    ],
    namesizef: "22px",
    namesizeb: "13px",
    fsize: "11px",
    isize: "100%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/roomsensorpro"
  },
  {
    id: 71,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Panel Plus",
    details: "10.1-inch Intelligent Room Scheduling Solution",
    image: y71,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Display: 10.1\" LCD Panel, 10-point Capacitive Multitouch",
      "2 Million Pixels",
      "1x Fast Ethernet Port (10/100Mbps)",
      "Microphone: 2x Microphones, Speaker: 2x Speakers",
      "Ambient Light Sensor, TOF Proximity Sensor"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "11px",
    isize: "100%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/roompanel-plus"
  },
  {
    id: 72,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Sensor",
    details: "Enterprise Multifunctional Room Sensor",
    image: y72,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Detection: Occupancy, Temperature, Humidity, Light",
      "Housing: PC, White",
      "Occupancy Type: Passive Infrared Tech",
      "PIR Detection Angle: 120°",
      "Sensor Adjustable Angle: ±20°"
    ],
    namesizef: "25px",
    namesizeb: "15px",
    fsize: "11px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/roomsensor"
  },
  {
    id: 73,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Panel ",
    details: "Smart Room Scheduling Device",
    image: y73,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Display: 8\" LCD Panel, Resolution: 1280x800",
      "Audio: 2x Array Microphones, 2x Watt Speakers",
      "12V Power Adapter",
      "Mounting Options: Surface mount for 2-gang US electrical box, 20° tilt mount kit for wall or glass, Flush mount kit for wall or glass",
      "Bluetooth 5.0, 802.11ac Wi-Fi"
    ],
    namesizef: "25px",
    namesizeb: "15px",
    fsize: "11px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/roompanel"
  },
  {
    id: 74,
    title: "Microsoft & Zoom Devices",
    subtitle: "AIOT Room Device",
    name: "Room Cast ",
    details: "Seamless and Intuitive Wireless Presentation System",
    image: y74,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "4K/60FPS",
      "Yealink Wireless Presentation Pod",
      "Supports Miracast, AirPlay, Google Cast",
      "4-Screen Casting",
      "Virtual Whiteboard",
      "Intuitive Remote Control"
    ],
    namesizef: "25px",
    namesizeb: "15px",
    fsize: "12px",
    isize: "100%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/roomcast"
  },

  {
    id: 75,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "CM50",
    details: "Premium Dante Beamforming Ceiling Microphone",
    image: y75,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Dante Microphone",
      "127 Microphone Units",
      "5-meter Radius High-Quality Pickup",
      "AI-Based Sound Optimization",
      "8 Custom Pickup Areas",
      "Acoustic Adaptation",
      "AI Feedback Suppression",
      "Sound Source Localization"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/cm50"
  },
  {
    id: 76,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "AP08",
    details: " Digital Signal Processor",
    image: y76,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "16*16 Dante Channel",
      "8 AEC Channels",
      "Yealink Room Designer",
      "AI-Based Sound Optimization",
      "One-Button Deployment",
      "Intelligent Design",
      "Acoustic Adaptation"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "12px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/ap08"
  },
  {
    id: 77,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: " CM20 ",
    details: "AI-Powered Beamforming Ceiling Microphone",
    image: y77,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Frequency Response: 120Hz-16kHz",
      "Maximum SPL: 122dBSPL",
      "Signal Noise Ratio: 86dB @<1% THD",
      "Sensitivity: 0 dBV/Pa 94dBSPL@1kHz",
      "16 Omni-Direction Microphones",
      "1 Internal AEC Channel"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "11px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/accessories-cm20"
  },
  {
    id: 78,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "CS10/CS10-D",
    details: "Network Ceiling Loudspeaker for Audio Clarity",
    image: y78,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Frequency Response (-6dB): 100-20kHz",
      "Maximum SPL: Continuous: 99dB @20W 1m",
      "LF: 5.7-inch woofer, HF: 1.1-inch tweeter",
      "Nominal Impedance: 8Ω",
      "Nominal Coverage Angle: 120",
      "Size: ф294 × H125.8mm (with cover mesh)"
    ],
    namesizef: "19px",
    namesizeb: "11px",
    fsize: "12px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/accessories-cs10-cs10-d"
  },
  {
    id: 79,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "CMKit-121 ",
    details: "Yealink Audio Ceiling Solution",
    image: y79,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "16 Omnidirectional Microphone Units",
      "8 Independent Pickup Zones",
      "AI Dynamic Noise Reduction",
      "AI Reverberation Suppression",
      "CM20 Ceiling Microphone",
      "CS10 Ceiling Speakers"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "10px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/cmkit-121"
  },
  {
    id: 80,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "CP50 ",
    details: "Video Conference Omnidirectional Microphone",
    image: y80,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "8-Element Omnidirectional Microphone Array",
      "Crystal-Clear Natural Voice Reproduction",
      "Intelligent Noise and Echo Cancellation",
      "Full-Duplex Communication",
      "Easy Deployment with 8-Device Daisy-Chaining",
      "Plug-and-Play"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "10px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/cp50"
  },
  {
    id: 81,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "CPE40 ",
    details: "Conference Omnidirectional Microphone",
    image: y81,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Single POE Network Cable",
      "8-Element Omnidirectional Microphone Array",
      "Support 360° Audio Pickup",
      "Supports Full-Duplex Communication",
      "Single POE network cable",
      "Yealink's Advanced Audio and AI Algorithms"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "10px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/cpe40"
  },

  {
    id: 82,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "VCM36-W",
    details: " Wireless Microphone",
    image: y82,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Optimal HD Audio",
      "Yealink Full Duplex Technology",
      "Yealink Acoustic Echo Canceling",
      "6m Voice Pickup Range",
      "Muting the microphone with touchpad",
      "Touchpad Muting Functionality",
      "Built-in 2450 mAh Battery",
      "Up to 12 Hours of Use Time",
      "Up to 7 Days Standby Time"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "10px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/accessories-vcm36-w"
  }, {
    id: 83,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "VCM35",
    details: "Advanced Video Conferencing Microphone Array with Full-Duplex Technology",
    image: y83,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Optima HD Audio",
      "Yealink Full Duplex Technology",
      "Yealink Acoustic Echo Canceling",
      "Yealink Noise Proof Technology",
      "Voice Activity Detection (VAD)",
      "360° 5m Omnidirectional Pickup",
      "Muting the Microphone with Touchpad",
      "Frequency Response: 100Hz to 8kHz"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "10px",
    isize: "80%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/accessories-vcm35"
  },
  {
    id: 84,
    title: "Microsoft & Zoom Devices",
    subtitle: "Room Audio Devices",
    name: "VCM34",
    details: "Efficient Microphone Array for Professional Video Conferencing",
    image: y84,
    colors: "linear-gradient(90deg, #0085FF 0%, #3A73A8 91.49%, #666666 100%)",
    backDetails: [
      "Optimal HD Audio",
      "Yealink Acoustic Echo Canceling",
      "6m Voice Pickup Range",
      "Built-In 2450 mAh Battery",
      "Up to 12 Hours of Use Time",
      "Up to 7 Days Standby Time",
      "Frequency Response: 100Hz to 8kHz",
      "Dimension (WDH): Microphone: 100 x 16.5 mm, Charge Cradle: 100 x 10.5 mm"
    ],
    namesizef: "25px",
    namesizeb: "20px",
    fsize: "10px",
    isize: "70%",
    bsize: "0px",
    weblink: "https://www.yealink.com/en/product-detail/accessories-vcm3"
  }











































];
export default yealinkproductdata;